import { useRef } from 'react';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import {
  Button,
  Card,
  CardActionArea,
  Collapse,
  Divider,
  Grid,
  IconButton,
  List,
  MenuItem,
  Paper,
  Popover,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Typography,
  useMediaQuery,
  Avatar,
} from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import Loading from 'assets/images/loading.png';
import Dialog from '@mui/material/Dialog';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import StepConnector, {
  stepConnectorClasses,
} from '@mui/material/StepConnector';
import { makeStyles } from '@mui/styles';
import { Box, styled, useTheme } from '@mui/system';
import Exchange from 'assets/images/Exchange.png';
import kiel from 'assets/images/kiel.png';
import Man from 'assets/images/Man.png';
import userIcon from 'assets/svg/userIcon.png';
import { datacontext } from 'modules/AppLayout/AppLayout';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import BuyerIndividualBanners from './BuyerIndividualBanners';
import {
  poppins300,
  poppins400,
  poppins500,
  poppins600,
  poppins700,
} from 'theme/common.style';
import DeleteIcon from '../../assets/images/DeleteIcon.png';
import PdfIcon from '../../assets/images/pdficon.png';
import DecreasingCounter from './DecreasingCounter';
import Spinner from './Spinner';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import Tab from '@mui/material/Tab';
import Worldnet from 'assets/images/Worldnet.png';
import { ExpandLessOutlined, ExpandMoreOutlined } from '@mui/icons-material';
import { DateCalendar, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {
  confirmBuyerOffer,
  getBuyerIndividualData,
  getChecklistMaster,
  getDueDelligenceFile,
  getFollowRequest,
  getlistMakeOffer,
  getlistPrivateInspection,
  getlistScheduledInspection,
  Moxoseparationinlisting,
  postApiCall,
  scheduleInspection,
  stageTwoView,
  viewContract,
  formatDateTime,
} from 'api/apiService';
import BackArrow from 'assets/images/BackArrow.png';
import { ReactComponent as Fireemoji } from 'assets/svg/Fireemoji.svg';
import { WarningLite } from 'component/BuyerRegistration/components/WarningLite';
import { DueDiligence } from './DueDiligence';
import { MakeOffers, Pendingwarning } from './MakeOffers';
import {
  Dot,
  GreenDot,
  Locationsmallblack,
  SearchHouse,
  DueIcon,
  Form,
  OfferIcon,
  CheckTick,
  CalenderSCGNew,
  Expand,
  DownArrowRed,
  Uparrow,
  Makeoffer,
  Alert,
  Viewoffer,
  OfferHistory,
  SearchIconNew,
  Warning,
  Sign,
  Shield1,
  ContractIconNew,
  DiligenceIconNew,
  MakeOfferIconNew,
  HighestOffersSVG,
  MakeOffersSVG,
  FocusModeIcon,
  OrangePendingwarning,
} from './Marketplaceicons';
import { ViewContact } from './ViewContract';
import {
  APP_SCALE,
  BUYER_REQUESTSTAGE2,
  BUYER_REQUEST_ESIGN,
  DESKTOP_BREAKPOINT,
  REQUEST_CONTRACT,
  BUYER_UPLOAD_APPROVED_CONTRACT,
  USER_TYPE,
} from 'constant/app.config';
import moment from 'moment';
import {
  useHistory,
  useParams,
} from 'react-router-dom/cjs/react-router-dom.min';
import BuyerManageOffer from './BuyerManageOffer';
import Offer1 from 'assets/images/Offer.png';
import MessagingContainer from 'component/MessagingContainer/MessagingContainer';
import { ToggleOn } from 'component/OwnerCard/OwnerCard';
import { PropertyContext } from 'component/PropertyContext/PropertyContext';
import PropertyTimer, { PauseIcon } from 'component/PropertyTime/PropertyTimer';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone.js';
import utc from 'dayjs/plugin/utc';
import { isArray } from 'lodash';
import { useDropzone } from 'react-dropzone';
import MediaQuery from 'react-responsive';
import { MarketInvitePopup } from './MarketInvitePopup';
import './MarketStyle.css';
import Commonfile from './Commonfile';
import { Clock } from './Marketplaceicons';
import { CheckLists } from './CheckLists';
import FocusModePopup from './FocusModePopup';
import { useLocation } from 'react-router-dom';
import DepositPaymentRemittancePopup from './DepositPaymentRemittancePopup';
import { Tooltip } from '@mui/material';
import ConfirmingParticipationStageTwo from './ConfirmingParticipationStageTwo';
import SolicitorPopupHandler from './Solicitorhandler/SolicitorPopupHandler';
import NameTooltip from 'component/Common/NameTooltip';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Australia/Sydney');

const FlexBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
}));

const DropZone = styled(FlexBox)(({ isDragActive, theme }) => ({
  width: '100%',
  height: 160,
  cursor: 'pointer',
  marginBottom: '16px',
  borderRadius: '4px',
  justifyContent: 'center',
  transition: 'all 350ms ease-in-out',
  border: '2px dashed rgba(108, 42, 210, 1)',
  background: isDragActive ? 'rgb(0, 0, 0, 0.15)' : '#f0e9fa',
}));

const useStyles = makeStyles((theme) => ({
  weekName: {
    color: '#8F91BC',
    fontFamily: 'Poppins !important',
    fontSize: '24px !important',
    fontWeight: '700 !important',
  },
  calendarContainer: {
    border: '1px solid lightgray',
    borderRadius: '8px',
    boxShadow: '4px 4px 18px 0px rgba(0, 0, 0, 0.1)',
    height: '396px',
    width: '442px',
    padding: '10px 20px 20px 20px',
  },
  cell: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '4rem',
    fontSize: '14px',
    fontFamily: 'Poppins',
    fontWeight: '700',
    color: '#2C3643',
    height: '2.5rem',
    paddingLeft: '2.5rem',
  },
  monthHeader: {
    fontSize: '20px !important',
    fontFamily: 'Poppins !important',
    fontWeight: '700 !important',
    color: '#2C3643',
  },
  disabledSelect: {
    '& .MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled':
      {
        '-webkit-text-fill-color': '#112347 !important',
        opacity: 1,
      },
  },
}));

export const ToggleOff = () => {
  return (
    <svg
      width="42"
      height="25"
      viewBox="0 0 42 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.459961"
        y="0.370483"
        width="41.54"
        height="24.3705"
        rx="12.1852"
        fill="url(#paint0_linear_9124_97512)"
      />
      <ellipse
        cx="12.981"
        cy="12.5557"
        rx="8.52103"
        ry="8.86199"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_9124_97512"
          x1="12.7341"
          y1="-1.66162"
          x2="18.2578"
          y2="28.3495"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#6C2AD2" />
          <stop offset="1" stop-color="#77CFFE" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const MarketPlace = ({
  isAuction,
  auctionDetails,
  setHideActivateTrade,
  hideActivateTrade,
  setShowActivateTrade,
  hideConfirmBox,
  getBuyerIndividualValue,
  setHideConfirmBox,
  setGetBuyerIndividualValue,
  setTabDAta,
  tabData,
  groupIt,
  makeOfferRef,
  propertyIds,
  activityfun,
  isStickyTimer,
  isStickyTimerStage,
  stickyAnchorTimerRef,
  blurComp,
  setBlurComp,
  confirmAcceptLog,
  setConfirmAcceptLog,
  onClose,
  setOpenlogin,
  openlogin,
  sharedpage,
  collapsed,
  showActivateTrade,
  matchesxl,
  dateupdated,
  onShowChat,
  activityupdate,
  isHovered,
  setDialogOpen,
  isDialogOpen,
  handleClick,
  handleMouseLeave,
  setIsHovered,
  directcomm,
  newTabData,
  setNewTabData,
  hideOthers,
  SetHideOthers,
  setShowPropertyTimer,
  showPropertyTimer,
  offerHistoryState,
  isBinderChatOpen,
  setOfferHistoryState,
  isMakeanOffer,
  setIsMakeanOffer,
  isDisabled,
  handleMakeOfferClick,
  setPaymentPop,
  paymentPop,
  marketScrollRef,
  isSticky,
  setIsSticky,
  isStickyAddress,
  setIsStickyAddress,
  scrollToMakeOffer,
  setScrollToMakeOffer,
  scrollTotabRef,
}) => {
  const offerPrice =
    getBuyerIndividualValue?.PropertyDetails?.offerStatus?.price;
  useEffect(() => {
    if (tabData && tabData !== value) {
      setValue(tabData);
    }
  }, [tabData]);
  const handlemakeoffertab = () => {
    setTabDAta('4'); // switch tab
    setScrollToMakeOffer(true); // express intent
    scrollTotabRef.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };
  useEffect(() => {
    if (scrollTotabRef.current) {
      scrollTotabRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, [tabData]);

  const [isFollowLoading, setIsFollowLoading] = useState(false);
  const isNotEmptyArray = (arr) =>
    Array.isArray(arr) &&
    arr.length > 0 &&
    !arr.every((item) => Array.isArray(item) && item.length === 0);

  const handleFollowClick = () => {
    const isFollowStatus =
      getBuyerIndividualValue?.PropertyDetails?.isFollowed == 0 ? 1 : 0;
    setIsFollowLoading(true);
    getFollowRequest(propertyId, 'Buyer', isFollowStatus)
      .then((res) => {
        if (res?.status == '1') {
          if (isNotEmptyArray(res?.dataForWatchlistAgentAck)) {
            Moxoseparationinlisting(
              'dataForWatchlistAgentAck',
              res?.dataForWatchlistAgentAck
            );
          }
          const currentUrl = window.location.href;
          getBuyerIndividualData(
            propertyId,
            currentUrl,
            userDetail?.primaryUserType
          ).then((res) => {
            if (res?.status == '1') {
              setGetBuyerIndividualValue(res);
            } else {
              setGetBuyerIndividualValue({});
            }
            setIsFollowLoading(false);
          });
        } else {
          setIsFollowLoading(false);
        }
      })
      .catch(() => {
        setIsFollowLoading(false);
      });
  };

  const onCloseFunction = () => {
    setOfferHistoryState(false);
    SetHideOthers(false);
    if (showPropertyTimer) {
      setTabDAta(tabData);
      setShowPropertyTimer(false);
    }
  };

  const theme = useTheme();
  const matches1500 = useMediaQuery(theme.breakpoints.down(1500));
  const matches900 = useMediaQuery(theme.breakpoints.down(900));
  const [dontallowtooffer, setDontallowtooffer] = useState(false);
  const [action, setAction] = useState('Action');
  const [doc66wstatus, setDoc66wstatus] = useState();
  const [st1condition, setSt1condition] = useState();
  const [st2condition, setSt2condition] = useState();
  const [isFirstOffer, setIsFirstOffer] = useState();
  const isDesktop = useMediaQuery(`(min-width:${DESKTOP_BREAKPOINT}px)`);
  const [isStageTwoRequested, setIsStageTwoRequested] = useState();
  const [isConditionalChanceCompleted, setIsConditionalChanceCompleted] =
    useState();
  const [withdrawLeftCount, setwWithdrawLeftCount] = useState();
  const [value, setValue] = React.useState(tabData === 1 ? '1' : tabData);
  const [open, setOpen] = React.useState(false);
  const [highestOfferBox, setHighestOfferBox] = useState(false);
  const scrollContainerRef = useRef(null);
  const [selectOpen, setSelectOpen] = useState(false);
  const [propertyInspected, setPropertyInspected] = useState(false);
  const [dueDiligence, setDueDiligence] = useState(false);
  const [viewContractBuyer, setViewContractBuyer] = useState(false);
  const [contractReviewed, setContractReviewed] = useState(false);
  const [signContract, setSignContract] = useState(false);
  const [depositPaymentBuyer, setDepositPaymentBuyer] = useState(false);
  const [opensolicitorpopup, setOpensolicitorpopup] = useState(false);
  const [typeofsolicitorpopup, setTypeofsolicitorpopup] = useState(null);
  const data1 = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data1);
  const userId = userDetail?.userId;
  const offerStatusLastUpdated = formatDateTime(
    getBuyerIndividualValue?.PropertyDetails?.offerStatus?.lastUpdated
  );
  const lastUpdatedCounter = formatDateTime(
    getBuyerIndividualValue?.PropertyDetails?.offerStatus?.lastUpdatedCounter
  );

  const [openFocusDialog, setOpenFocusDialog] = useState(false);

  const handleClickOpenFocus = () => {
    setOpenFocusDialog(true);
  };

  const location = useLocation();
  const { openFocusModeST2, offerIconActionST1, dashboardCounterOfferView } =
    location.state || {};

  useEffect(() => {
    if (dashboardCounterOfferView) {
      history.push({
        pathname: history?.location?.pathname,
        state: { propertyIds: true, dashboardCounterOfferView: false },
      });
    }
  }, [dashboardCounterOfferView]);

  const handleCloseFocus = () => {
    setOpenFocusDialog(false);
  };

  const handleChanged = (event, newValue) => {
    if (sharedpage) {
      if (newValue == 2) {
        setOpenlogin(!openlogin);
      }
    } else {
      setValue(newValue);
      setIsMakeanOffer(false);
    }
  };

  const { isAiMonitorBanner } =
    !sharedpage && location.state ? location.state : {};

  // this state check Active Trade Assist, "Active"
  const [showActivateTradeForSharePage, setShowActivateTradeForSharePage] =
    useState(false);

  const showActivate =
    location.state?.showActivateTradeForSharePageValue ?? false;

  // from share page login update "pages" using useEffect

  useEffect(() => {
    if (showActivate === true) {
      setShowActivateTrade(true);
      setHideActivateTrade(false);
      setHideConfirmBox(false);
    }
  }, [showActivate]);

  const params = useParams();
  let status;
  let propertyId = params?.propertyId;
  const [trigger, setTrigger] = React.useState(false);
  const [file, setFile] = useState([]);
  const [isViewed, setIsViewed] = useState(0);
  const [statusval, setStatusval] = useState();
  const [openShare, setOpenShare] = useState(false);
  const [offersOnly, setOffersOnly] = useState(false);

  const handleClickOpen = () => {
    setOpenShare(true);
  };

  const handleClose = (value) => {
    setOpenShare(false);
  };

  const cntrlfunc = () => {
    viewContract(`${propertyId}/${isViewed}`).then((res) => {
      status = res?.ViewContractStatus;
      setStatusval(res?.ViewContractStatus);
      if (res?.status == 1) {
        groupCall();
        if (status.includes('Requested')) {
          setIsViewed(1);
        }

        setFile(res?.ViewContract);
      } else {
        setFile([]);
      }
    });
  };

  useEffect(() => {
    if (statusval == 'Requested' || 'Pending') {
      const timer = setTimeout(() => {
        setTrigger(!trigger);
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, [statusval]);

  const [amendMedia, setAmendMedia] = useState([]);
  const [contractMedia, setContractMedia] = useState([]);
  const [pdfErrorOpen, setPdfErrorOpen] = useState(false);
  const [pdfErrorFile, setPdfErrorFile] = useState('');
  const [pdfErrorOpen1, setPdfErrorOpen1] = useState(false);
  const [pdfErrorFile1, setPdfErrorFile1] = useState('');

  const MAX_FILE_SIZE = 15 * 1024 * 1024;
  const onDrop = useCallback(
    (newFiles) => {
      const validFiles = newFiles.filter((file) => file.size <= MAX_FILE_SIZE);
      const invalidFiles = newFiles.filter((file) => file.size > MAX_FILE_SIZE);

      if (invalidFiles.length > 0) {
        setPdfErrorOpen(true);
        setPdfErrorFile(newFiles[0].name);
        Swal.fire({
          title: 'Limit Exceeded!',
          text: 'Please upload a file smaller than 15 MB',
          showDenyButton: false,
          showCancelButton: false,
          icon: 'error',
          confirmButtonText: 'Close',
        });
      }

      setAmendMedia(() => [...validFiles]);
    },
    [setAmendMedia]
  );
  const onDrop1 = useCallback(
    (newFiles) => {
      const validFiles = newFiles.filter((file) => file.size <= MAX_FILE_SIZE);
      const invalidFiles = newFiles.filter((file) => file.size > MAX_FILE_SIZE);

      if (invalidFiles.length > 0) {
        setPdfErrorOpen1(true);
        setPdfErrorFile1(newFiles[0].name);
        Swal.fire({
          title: 'Limit Exceeded!',
          text: 'Please upload a file smaller than 15 MB',
          showDenyButton: false,
          showCancelButton: false,
          icon: 'error',
          confirmButtonText: 'Close',
        });
      }

      setContractMedia(() => [...validFiles]);
    },
    [setAmendMedia]
  );

  const {
    getRootProps: getContractRootProps,
    getInputProps: getContractInputProps,
    acceptedFile,
  } = useDropzone({
    onDrop: onDrop1,
    accept: { 'application/pdf': [] },
    multiple: false,
  });
  const { getRootProps, getInputProps, isDragAccept, isDragReject } =
    useDropzone({
      onDrop,
      accept: { 'application/pdf': [] },
      multiple: false,
    });
  const [amendUploadStatus, setAmendUploadStatus] = useState(
    'Upload PDF file only, max size limit 15MB'
  );
  const [contractUploadStatus, setContractUploadStatus] = useState(
    'Upload PDF file only, max size limit 15MB'
  );

  const handleAmendFileUpload = (event) => {
    const chosenFiles = Array.prototype.slice.call(event.target.files);
    handleAmendUploadFiles(chosenFiles);
    const selectedFiles = event.target.files;

    if (selectedFiles.length > 0) {
      const newMedia = [...amendMedia];

      for (let i = 0; i < selectedFiles.length; i++) {
        newMedia.push(selectedFiles[i]);
      }

      setAmendUploadStatus('Document Uploaded Successfully');
    } else {
      Swal.fire({
        title: 'Error',
        text: 'Please select a file to upload',
        showDenyButton: false,
        showCancelButton: false,
        icon: 'error',
        confirmButtonText: 'Close',
      }).then((result) => {
        if (result.isConfirmed) {
        } else if (result.isDenied) {
          return;
        }
      });
      setAmendUploadStatus('Upload PDF file only, max size limit 15MB');
    }
  };

  const handleContractFileUpload = (e) => {
    const chosenFiles = Array.prototype.slice.call(e.target.files);
    handleContractUploadFiles(chosenFiles);
    const selectedFiles = e.target.files;

    if (selectedFiles.length > 0) {
      const newMedia = [...contractMedia];

      for (let i = 0; i < selectedFiles.length; i++) {
        newMedia.push(selectedFiles[i]);
      }

      setContractUploadStatus('Document Uploaded Successfully');
    } else {
      Swal.fire({
        title: 'Error',
        text: 'Please select a file to upload',
        showDenyButton: false,
        showCancelButton: false,
        icon: 'error',
        confirmButtonText: 'Close',
      }).then((result) => {
        if (result.isConfirmed) {
        } else if (result.isDenied) {
          return;
        }
      });
      setContractUploadStatus('Upload PDF file only, max size limit 15MB');
    }
  };

  const handleAmendUploadFiles = (files) => {
    const uploaded = [...amendMedia];
    files.some((file) => {
      if (file.type !== 'application/pdf') {
        Swal.fire({
          title: 'Error',
          text: 'Please upload a PDF file',
          showDenyButton: false,
          showCancelButton: false,
          icon: 'error',
          confirmButtonText: 'Close',
        }).then((result) => {
          if (result.isConfirmed) {
          } else if (result.isDenied) {
            return;
          }
        });
      } else if (file.size > 15e6) {
        setAmendMedia([]);
        Swal.fire({
          title: 'Limit Exceeded!',
          text: 'Please upload a file smaller than 15 MB',
          showDenyButton: false,
          showCancelButton: false,
          icon: 'error',
          confirmButtonText: 'Close',
        }).then((result) => {
          if (result.isConfirmed) {
          } else if (result.isDenied) {
            return;
          }
        });
      } else {
        uploaded.push(file);
        setAmendMedia(uploaded);
      }
    });
  };
  const handleContractUploadFiles = (files) => {
    const uploaded = [...contractMedia];
    files.some((file) => {
      if (file.type !== 'application/pdf') {
        Swal.fire({
          title: 'Error',
          text: 'Please upload a PDF file',
          showDenyButton: false,
          showCancelButton: false,
          icon: 'error',
          confirmButtonText: 'Close',
        }).then((result) => {
          if (result.isConfirmed) {
          } else if (result.isDenied) {
            return;
          }
        });
      } else if (file.size > 15e6) {
        Swal.fire({
          title: 'Limit Exceeded!',
          text: 'Please upload a file smaller than 15 MB',
          showDenyButton: false,
          showCancelButton: false,
          icon: 'error',
          confirmButtonText: 'Close',
        }).then((result) => {
          if (result.isConfirmed) {
          } else if (result.isDenied) {
            return;
          }
        });
      } else {
        uploaded.push(file);
        setContractMedia(uploaded);
      }
    });
  };

  const Submit = async () => {
    setLoading(true);

    try {
      let propertyId = params?.propertyId;

      const formData = new FormData();
      formData.append('propertyId', propertyId);

      if (amendMedia?.length > 0) {
        amendMedia.forEach((item) => {
          formData.append('approvedContract', item);
        });
      }
      if (contractMedia?.length > 0) {
        contractMedia.forEach((item) => {
          formData.append('amendmentsContract', item);
        });
      }
      formData.append('isSelf', toggle ? 0 : 1);
      if (toggle) {
        formData.append('legalName', firstName?.trim());
        formData.append('legalLastName', lastName?.trim());
        formData.append('legalEmail', email);
      }

      const response = await postApiCall(
        BUYER_UPLOAD_APPROVED_CONTRACT,
        formData
      );

      const resData = response?.data || response;

      if (resData?.status == -1) {
        Swal.fire({
          title: resData?.heading || 'Error',
          text: resData?.message || 'Upload failed',
          showDenyButton: false,
          showCancelButton: false,
          icon: 'error',
          confirmButtonText: 'Close',
        });
      } else {
        setUploadDocuments(false);
        setAmendMedia([]);
        cancelFunc();
        groupCall();

        Swal.fire({
          title: resData?.heading || 'Success',
          text: resData?.message || 'Uploaded successfully',
          showDenyButton: false,
          showCancelButton: false,
          icon: 'success',
          confirmButtonText: 'Close',
        });

        if (typeof onClose == 'function') {
          onClose();
        }
      }
    } catch (error) {
      Swal.fire({
        title: 'Error',
        text: error?.message || 'Something went wrong',
        icon: 'error',
        confirmButtonText: 'Close',
      });
    } finally {
      setLoading(false);
    }
  };

  const InfoIcon = () => {
    return (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_25231_159917)">
          <path
            d="M12.5 21.875C17.6777 21.875 21.875 17.6777 21.875 12.5C21.875 7.32233 17.6777 3.125 12.5 3.125C7.32233 3.125 3.125 7.32233 3.125 12.5C3.125 17.6777 7.32233 21.875 12.5 21.875Z"
            stroke="#EEAD06"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.5 17.7083V17.7187"
            stroke="#EEAD06"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.5013 14.0627C12.4821 13.7246 12.5733 13.3893 12.7612 13.1075C12.9491 12.8257 13.2235 12.6126 13.543 12.5002C13.9345 12.3505 14.2859 12.1119 14.5696 11.8033C14.8533 11.4947 15.0614 11.1244 15.1777 10.7217C15.2939 10.3189 15.3151 9.89468 15.2396 9.48236C15.164 9.07004 14.9938 8.68089 14.7423 8.34554C14.4907 8.01019 14.1648 7.7378 13.7901 7.54982C13.4155 7.36183 13.0023 7.26338 12.5831 7.26222C12.1639 7.26105 11.7502 7.35721 11.3745 7.54312C10.9988 7.72902 10.6713 7.9996 10.418 8.33355"
            stroke="#EEAD06"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_25231_159917">
            <rect width="25" height="25" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  };

  const [isDialogOpenSticky, setDialogOpenSticky] = useState(false);
  const [isHoveredSticky, setIsHoveredSticky] = useState(false);
  const [anchorElSticky, setAnchorElSticky] = useState(null);

  const [openloginSticky, setOpenloginSticky] = useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [icons, setIcon] = useState('');
  const [popoverStatusName, setPopoverStatusName] = useState('');
  const [popoverStatusList, setPopoverStatusList] = useState('');
  const [checkListStatus, setCheckListStatus] = useState('');
  const [formatETAStatus, setFormatETAStatus] = useState('');
  const [formatLastUpdate, setFormatLastUpdate] = useState('');
  const [wList1, setWList1] = useState('');
  const [wList2, setWList2] = useState('');

  const handleMouseLeaveSticky = () => {
    setTimeout(() => {
      setIsHoveredSticky(false);
    }, 1500);
  };

  const handleClickSticky = (event) => {
    if (sharedpage) {
      setOpenloginSticky(!openloginSticky);
    } else {
      setAnchorElSticky(event.currentTarget);
      setDialogOpenSticky(true);
    }
  };

  const handleCloseCheck = () => {
    setAnchorEl(null);
  };

  const openCheck = Boolean(anchorEl);
  const idCheck = openCheck ? 'simple-popover' : undefined;

  const checkListPopList = [
    'View and track any upcoming inspections for this property.',
    'Track your progress whilst you carry out due diligence.',
    'After requesting the property contract of sale, you are able to forward the contract to your solicitor for review.',
    'Once you have forwarded the property purchase contract to your legal representative for review, you will be able to track the progress of the contract review. Once the review process is completed, any amendments or updates approved by the Vendor will be made available.',
    'When buying a property in New South Wales (NSW) Australia, after the exchange of contracts, there is usually a five day cooling off period prior to the contract becoming binding and enforceable. The cooling off period can be waived by having your solicitor issue a  s66W certificate. By submitting a signed s66W certificate, later when the sale contract is signed by both parties it will be immediately binding without any cooling off period.',
    'Review the contract and sign electronically to confirm your agreement to proceed with the purchase.',
    'Pay your deposit for this property. Your agent will confirm receipt before the transaction can progress to settlement.',
  ];

  const [anchorEll, setAnchorEll] = useState(null);

  const openn = Boolean(anchorEll);
  const id = openn ? 'simple-popover' : undefined;

  const checkListPop = (
    renderIcon,
    taskName,
    index,
    event,
    task,
    formattedETA,
    formattedLastUpdated
  ) => {
    if (taskName != 'Sign Contract' && taskName != 'Deposit Payment') {
      setPopoverStatusName(taskName);
      setIcon(renderIcon);
      setAnchorEl(event.currentTarget);
      setPopoverStatusList(checkListPopList[index]);
      setCheckListStatus(task);
      setFormatETAStatus(formattedETA);
      setFormatLastUpdate(formattedLastUpdated);
      if (taskName == '66w Certificate') {
        setWList1(
          'It is common practice for buyers to include a signed s66W during the offering process to strengthen their offers.'
        );
        setWList2(
          ' of winning buyers provided a signed s66w certificate in advance.'
        );
      } else {
        setWList1('');
        setWList2('');
      }
    }
  };

  const submitOffer = (amount) => {
    var txt = amount;
    var vendorOffer = txt.match(/\d/g);
    vendorOffer = vendorOffer.join('');

    const input = {
      offerUniqueId:
        getBuyerIndividualValue?.PropertyDetails?.offerStatus?.offerUniqueId,
      buyerStatus: 'Accepted',
      vendorOfferPrice: vendorOffer,
    };
    confirmBuyerOffer(input).then(async (res) => {
      groupIt();
      if (res?.status == '1') {
        if (isNotEmptyArray(res?.dataForBuyerCounterAck))
          Moxoseparationinlisting(
            'dataForBuyerCounterAck',
            res?.dataForBuyerCounterAck
          ); //1
        await setOpenBox(!openBox);
        await Swal.fire({
          title: res?.heading ? res?.heading : 'Success',
          text: res?.message,
          showDenyButton: false,
          showCancelButton: false,
          icon: 'success',
          confirmButtonText: 'Close',
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
          } else if (result.isDenied) {
            return;
          }
        });
      } else {
        await setOpenBox(!openBox);
        await Swal.fire({
          title: res?.heading ? res?.heading : 'Error',
          text: res?.message,
          showDenyButton: false,
          showCancelButton: false,
          icon: 'error',
          confirmButtonText: 'Close',
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
          } else if (result.isDenied) {
            return;
          }
        });
      }
    });
  };
  const slotProps = {
    leftArrowIcon: { fontSize: 'large' },
    rightArrowIcon: { fontSize: 'large' },
    previousIconButton: {
      size: 'medium',
    },
    nextIconButton: {
      size: 'medium',
    },
  };
  const tabs = [
    {
      label: (
        <Grid
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
          onClick={() => setTabDAta('1')}
        >
          <Typography sx={{ width: '40px', height: '40px' }}>
            <SearchHouse color={value === '1' ? '#6C2AD2' : '#666666'} />
          </Typography>
          <Typography
            sx={{
              ...poppins500,
              fontSize: '14px',
              color: value === '1' ? '#6C2AD2' : '#666666',
            }}
          >
            Organise Inspection
          </Typography>
        </Grid>
      ),
      value: '1',
    },
    {
      label: (
        <Grid
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
          onClick={() => setTabDAta('3')}
        >
          <Typography sx={{ width: '40px', height: '40px' }}>
            <DueIcon color={value === '3' ? '#6C2AD2' : '#666666'} />
          </Typography>
          <Typography
            sx={{
              ...poppins500,
              fontSize: '14px',
              color: value === '3' ? '#6C2AD2' : '#666666',
            }}
          >
            {' '}
            Due Diligence
          </Typography>
        </Grid>
      ),
      value: '3',
    },
    {
      label: (
        <Grid
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
          onClick={() => {
            if (!sharedpage) {
              setTabDAta('2');
            }
          }}
        >
          <Typography sx={{ width: '40px', height: '40px' }}>
            <Form color={value === '2' ? '#6C2AD2' : '#666666'} />
          </Typography>
          <Typography
            sx={{
              ...poppins500,
              fontSize: '14px',
              color: value === '2' ? '#6C2AD2' : '#666666',
            }}
          >
            View Contract
          </Typography>
        </Grid>
      ),
      value: '2',
    },

    {
      label: (
        <Grid
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
          onClick={() => {
            setTabDAta('4');
          }}
        >
          <Typography sx={{ width: '40px', height: '40px' }}>
            <OfferIcon color={value === '4' ? '#6C2AD2' : '#666666'} />
          </Typography>
          <Typography
            sx={{
              ...poppins500,
              fontSize: '14px',
              color: value === '4' ? '#6C2AD2' : '#666666',
            }}
          >
            {' '}
            Make Offer
          </Typography>
        </Grid>
      ),
      value: '4',
    },
  ];
  const classes = useStyles();
  const [currentDate, setCurrentDate] = useState(new Date());

  const handlePrevMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() - 1)
    );
  };

  const handleNextMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() + 1)
    );
  };

  const handleConfirmClick = () => {
    setOpenCard(true);
  };

  const CustomStepIcon1 = (props) => {
    const { active, completed } = props; // Destructure active and completed

    return (
      <div
        style={{
          zIndex: 10,
          color: completed ? 'white' : 'rgba(230, 242, 255, 1)', // Completed and active steps color
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 24,
          height: 24,
          borderRadius: '50%',
          backgroundColor: completed ? '#6C2AD2' : 'rgba(230, 242, 255, 1)', // Background for active/completed
        }}
      >
        {completed || active ? (
          <CheckTick color={completed ? 'white' : 'rgba(230, 242, 255, 1)'} />
        ) : null}{' '}
        {/* Remove the number for non-active/non-completed steps */}
      </div>
    );
  };

  const Completed = () => {
    return (
      <svg
        width="23"
        height="22"
        viewBox="0 0 23 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="11.5" cy="11" r="9.625" stroke="#10D35E" stroke-width="2" />
        <path
          d="M8.875 10.957L10.7312 12.8132L14.4435 9.10088"
          stroke="#10D35E"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  };

  const Pending = () => {
    return (
      <svg
        width="23"
        height="22"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="16.0007"
          cy="15.9987"
          r="14.6667"
          stroke="#F39800"
          stroke-width="3"
        />
        <path
          d="M12 15.9336L14.8284 18.762L20.4853 13.1052"
          stroke="#F39800"
          stroke-width="3"
          stroke-linecap="round"
        />
      </svg>
    );
  };

  const {
    IsStickyValue,
    realTimeLog,
    solicitorupdate,
    setShowMessage,
    setMessagedata,
  } = React.useContext(datacontext);

  const [checkListArray, setCheckListArray] = useState([]);
  const [scheduleListArray, setScheduleListArray] = useState([]);
  const [privateListArray, setPrivateListArray] = useState([]);
  const [makeOfferListArray, setMakeOfferListArray] = useState({});
  const [array, setArray] = useState();
  const [lastHighestOffers, setLastHighestOffers] = useState([]);
  const [lastLatestOffer, setLastLatestOffer] = useState([]);
  const [scheduleItemData, setScheduleItemData] = useState({});
  const [scheduleDate, setScheduleDate] = useState('');
  const [attendState, setAttendState] = useState(true);
  const [requestState, setRequestState] = useState(false);
  const [plannedState, setPlannedState] = useState(true);
  const [scheduleTime, setScheduleTime] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [openCard, setOpenCard] = useState(false);
  const [showTick, setShowTick] = useState(false);
  const [openBox, setOpenBox] = useState(false);
  const [openBoxSign, setOpenBoxSign] = useState(false);
  const [uploaddocumentsone, setUploadDocumentsone] = useState(false);
  const [uploaddocuments, setUploadDocuments] = useState(false);
  const [requesttoview, setRequesttoview] = useState(false);
  const [isLoading66w, setIsLoading66w] = useState(false);
  const [isLoadingSign, setIsLoadingSign] = useState(false);
  const [amend, setAmend] = useState(false);
  const [contractSale, setContractSale] = useState(true);
  const [toggle, setToggle] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [amendVal, setAmendVal] = useState(false);
  const [contractVal, setContractVal] = useState(false);
  const [firstVal, setFirstVal] = useState(false);
  const [lastVal, setLastVal] = useState(false);
  const [emailVal, setEmailVal] = useState(false);
  const [oneSelect, setOneSelect] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [onmouse, setOnMouse] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selecdtedInsp, setSelectedIns] = useState(null);
  const [deleteInsp, setDeleteInsp] = useState(0);
  const [editInsp, setEditInsp] = useState(0);
  const [openConfirmingPopup, setOpenConfirmingPopup] = useState(false);
  const [confirmPopupSource, setConfirmPopupSource] = useState('');

  useEffect(() => {
    let timer;

    const propertyDetails = getBuyerIndividualValue?.PropertyDetails;

    const shouldOpenPopup =
      propertyDetails?.stage === 'ST2' &&
      confirmAcceptLog === 0 &&
      propertyDetails?.isStageTwo === 1 &&
      propertyDetails?.timerStatus !== 'End';

    if (shouldOpenPopup) {
      timer = setTimeout(() => {
        setOpenConfirmingPopup(true);
      }, 500);
    } else {
      setOpenConfirmingPopup(false);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [
    confirmAcceptLog,
    realTimeLog,
    getBuyerIndividualValue?.PropertyDetails?.stage,
    getBuyerIndividualValue?.PropertyDetails?.isStageTwo,
    getBuyerIndividualValue?.PropertyDetails?.timerStatus,
  ]);

  function capitalize(str) {
    if (!str) return str; // Check for empty string
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }
  const handleEditClick = (item) => {
    setEditInsp(1);
    setSelectedIns(item?.inspectionId);
    const parsedDate = dayjs(item?.dateTime);
    setScheduleTime(parsedDate.format('HH:mm:ss'));
    setSelectedDate(parsedDate);
    setScheduleDate(parsedDate.format('YYYY-MM-DD'));
    setScheduleItemData({
      ...item,
      type: item?.insType || item?.type,
    });
    setRequestState(true);
    setTimeout(() => {
      calendarRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }, 100);
  };

  const handleCancelEdit = () => {
    setEditInsp(0);
    setSelectedIns(null);
    setScheduleTime('');
    setSelectedDate(null);
    setScheduleDate('');
    setScheduleItemData({});
    setDeleteInsp(0);
    setInsDate('');

    // Clear localStorage
    localStorage.removeItem('inspectionDate');
    localStorage.removeItem('inspectionTime');
    localStorage.removeItem('inspectionItem');
  };

  const handleEmail = (event) => {
    const email = event.target.value;
    setEmail(email);
    setEmailVal(false);
    const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (toggle && !emailPattern.test(email)) {
      setErrorMessage('Please enter a valid email address');
    } else {
      setErrorMessage('');
    }
  };

  useEffect(() => {
    if (location.state?.openBoxSignDashboard) {
      setOpenBoxSign(true);
    }
  }, [location.state]);

  useEffect(() => {
    if (toggle) {
      setFirstVal(false);
      setLastVal(false);
      setEmailVal(false);
      setFirstName('');
      setLastName('');
      setEmail('');
    }
  }, [toggle]);

  const cancelFunc = () => {
    setUploadDocumentsone(false);
    setAmend(false);
    setContractSale(false);
    setToggle(false);
    setContractMedia([]);
    setAmendMedia([]);
    setAmendVal(false);
    setContractVal(false);
    setFirstVal(false);
    setLastVal(false);
    setEmailVal(false);
    setFirstName('');
    setLastName('');
    setEmail('');
    setErrorMessage('');
    setOneSelect(false);
  };

  const uploadDocumentValidate = () => {
    if (
      !contractVal &&
      !firstVal &&
      !lastVal &&
      !emailVal &&
      contractMedia.length > 0
    ) {
      const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
      if (toggle && !emailPattern.test(email)) {
        setErrorMessage('Please enter a valid email address');
      } else {
        setErrorMessage('');
        Submit();
      }
    }
    if (contractMedia.length == 0) {
      setContractVal(true);
    } else {
      setContractVal(false);
    }
    if (amend && amendMedia.length == 0) {
      setAmendVal(true);
    } else {
      setAmendVal(false);
    }
    if (toggle) {
      if (firstName == '') {
        setFirstVal(true);
      } else {
        setFirstVal(false);
      }
      if (lastName == '') {
        setLastVal(true);
      } else {
        setLastVal(false);
      }
      if (email == '') {
        setEmailVal(true);
      } else {
        setEmailVal(false);
      }
    }
  };

  let date_part = '';
  let time_part = '';

  const rawDateTime = checkListArray[3]?.statusLastUpdatedAt;

  if (rawDateTime) {
    const parsed = dayjs(rawDateTime, 'YYYY-MM-DD HH:mm:ss');

    if (parsed.isValid()) {
      date_part = parsed.format('DD-MM-YYYY');
      time_part = parsed.format('HH:mm');
    }
  }

  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    // Clean up the interval to prevent memory leaks
    return () => clearInterval(interval);
  }, []);

  const formatTime = (time) => {
    return time.toLocaleTimeString('en-AU', {
      timeZone: 'Australia/Sydney',
      hour12: false,
    });
  };

  const currentTimeAus = new Date().toLocaleString('en-AU', {
    timeZone: 'Australia/Sydney',
    hour12: false,
  });
  const aus = currentTimeAus.split(',');
  const aus1 = aus[1].toString();
  const aus2 = aus1.split(':');

  const times = [
    '10:00:00 ',
    '11:00:00 ',
    '12:00:00 ',
    '14:00:00 ',
    '15:00:00 ',
    '16:00:00 ',
  ];

  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchesmdup = useMediaQuery(theme.breakpoints.up('md'));
  const matcheslgup = useMediaQuery(theme.breakpoints.up('lg'));
  const matchesxlIsSticky = useMediaQuery(theme.breakpoints.up('xl'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches550 = useMediaQuery(theme.breakpoints.down(550));
  const matches380 = useMediaQuery(theme.breakpoints.down(380));
  const matches400 = useMediaQuery(theme.breakpoints.down(400));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));
  const matches420 = useMediaQuery(theme.breakpoints.down(420));
  const matches510 = useMediaQuery(theme.breakpoints.down(510));
  const matches750 = useMediaQuery(theme.breakpoints.down(750));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const matches650 = useMediaQuery(theme.breakpoints.down(650));
  const matches1281 = useMediaQuery(theme.breakpoints.down(1281));
  const matchesBetween1330And1370 = useMediaQuery(
    theme.breakpoints.between(1330, 1370)
  );
  const matches600 = useMediaQuery(theme.breakpoints.down(600));
  const matches4 = useMediaQuery(theme.breakpoints.down(434));
  const matBet4 = useMediaQuery(theme.breakpoints.between(434, 500));
  const matBet = useMediaQuery(theme.breakpoints.between(500, 525));
  const matbeet = useMediaQuery(theme.breakpoints.between(525, 550));
  const matBeet = useMediaQuery(theme.breakpoints.between(550, 572));
  const matches820 = useMediaQuery(theme.breakpoints.down(820));
  const matchesup820 = useMediaQuery(theme.breakpoints.up(820));
  const matches950 = useMediaQuery(theme.breakpoints.down(950));
  const matches500 = useMediaQuery(theme.breakpoints.down(500));
  const matcheslgIsSticky = useMediaQuery(theme.breakpoints.up(1330));
  const matcheslgIsSti = useMediaQuery(theme.breakpoints.down(1919));
  const matcheslgIsStiup = useMediaQuery(theme.breakpoints.up(1919));
  const currentPage = window.location.pathname;
  const propertyInspectedSteps = ['Action Required', 'Scheduled', 'Completed'];
  const dueDiligenceSteps = ['Action Required', 'Reviewed'];
  const viewContractSteps = ['Action Required', 'Requested', 'Reviewed'];
  const contractReviewedSteps = ['Action Required', 'In Progress', 'Completed'];
  const SSwSteps = ['Action Required', 'Requested', 'Completed'];
  const signContractSteps = ['Action Required', 'Pending', 'Completed'];
  const depositPaymentSteps = ['Action Required', 'Processing', 'Completed'];

  const getSteps = (taskName) => {
    if (taskName === 'Property Inspected') return propertyInspectedSteps;
    if (taskName === 'Due Diligence') return dueDiligenceSteps;
    if (taskName === 'View Contract') return viewContractSteps;
    if (taskName === 'Contract Reviewed') return contractReviewedSteps;
    if (taskName === '66w Certificate') return SSwSteps;
    if (taskName === 'Sign Contract') return signContractSteps;
    if (taskName === 'Deposit Payment') return depositPaymentSteps;
  };

  const handleEntered = () => {};

  const CustomConnector = styled(StepConnector)(({ theme }) => ({
    width: '100%',
    marginLeft: '-20px',
    zIndex: 1, // Ensure the line stays behind the icons
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 12,
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundColor: 'rgba(230, 242, 255, 1)',
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundColor: '#6C2AD2',
        zIndex: -10, // Keep the line behind the icons
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      height: 1.4,
      border: 0,
      backgroundColor: 'rgba(230, 242, 255, 1)',
    },
  }));

  useEffect(() => {
    setNewTabData(false);
  }, [matchessm]);

  const buttonStyles = {
    base: {
      width: '100%',
      background: 'white',
      border: '1px solid #6C2AD2',
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      textAlign: 'left',
      height: '60px',
      borderRadius: '8px',
      boxShadow: 'none',
    },
    selected: {
      background: '#F0F0F0',
      opacity: 0.5,
      pointerEvents: 'none',
      color: '#C4C4C4',
    },
  };

  // Typography Styles
  const typographyStyles = {
    base: {
      color: '#6C2AD2',
      fontFamily: 'Poppins',
      fontSize: '20px',
      fontWeight: 300,
      textTransform: 'capitalize',
      textAlign: 'center',
      margin: '0 auto',
    },
    selected: {
      color: '#C4C4C4',
    },
  };

  // Cancel Button Styles
  const cancelButtonStyles = {
    background: 'white',
    border: '1px solid red',
    whiteSpace: 'nowrap',
    height: '60px',
    marginTop: '20px',
    boxShadow: 'none',
    borderRadius: '8px',
  };

  const cancelTextStyles = {
    color: 'red',
    fontFamily: 'Poppins',
    fontSize: '20px',
    fontWeight: 400,
    textTransform: 'capitalize',
    textAlign: 'center',
    margin: '0 auto',
  };

  const [hoverEffect, setHoverEffect] = useState(false);
  const [stageLoader, setStageLoader] = useState(false);
  const [changed, setChanged] = useState(false);
  const [selectedSolicitor, setSelectedSolicitor] = useState([]);
  const [selectedSolicitorlinked, setSelectedSolicitorlinked] = useState([]);
  const [data, setData] = useState({});
  const [selectedSolicitorlinkedstatus, setSelectedSolicitorlinkedstatus] =
    useState([]);
  const [selectedSolicitorId, setSelectedSolicitorId] = useState();
  const currentSydneyDate = dayjs()
    .tz('Australia/Sydney')
    .format('YYYY-MM-DD HH:mm:ss');

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const [expandedRows, setExpandedRows] = useState({});

  const handleIconClick = (index) => {
    setExpandedRows((prev) => ({ [index]: !prev[index] }));
  };

  const stageTwoViewFunc = () => {
    setStageLoader(true);
    const input = {
      propertyId: params?.propertyId,
      status: 'Accepted',
      isAccept: 1,
      isAcceptancePopup: 0,
    };
    stageTwoView(input).then((res) => {
      if (res?.status == 1) {
        setStageLoader(false);
        setBlurComp(false);
        groupCall();
        groupIt();
      } else {
        setStageLoader(false);
      }
    });
  };

  useEffect(() => {
    if (hoverEffect == true) {
      setTimeout(() => {
        setHoverEffect(false);
      }, 3900);
    }
  }, [hoverEffect]);

  useEffect(() => {
    if (isStickyTimer == true) {
      setHoverEffect(true);
    }
  }, [isStickyTimer]);

  const [isActive, setIsActive] = useState(false);
  const taskCodeMap = {
    Ins001: '1',
    Con001: '2',
    Due001: '3',
    default: '4',
  };

  // click offer icon form property card this action will happen

  useEffect(() => {
    if (offerIconActionST1) {
      setTabDAta('4');
      if (scrollTotabRef?.current) {
        scrollTotabRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    } else if (openFocusModeST2) {
      setOpenFocusDialog(true);
    }
  }, []);
  const handleTaskMapping = useCallback(() => {
    if (getBuyerIndividualValue?.PropertyDetails?.timerStatus === 'Pause') {
      setTabDAta('4');
      return;
    }
    if (isMakeanOffer || (dashboardCounterOfferView && !offerIconActionST1)) {
      setTabDAta('4');
      scrollTotabRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      return;
    }

    if (
      checkListArray?.length &&
      !isActive &&
      !matchessm &&
      !offerIconActionST1 &&
      !isMakeanOffer
    ) {
      setIsMakeanOffer(false);
      const localIsActive = true; // Simulate the `isActive` state before React updates it.
      setIsActive(localIsActive);

      let task = checkListArray?.find((task) => task?.isDone === 0);

      while (
        task?.taskCode === 'Due001' &&
        !data?.StrataLink?.propertyMedia &&
        !data?.BuildingPestLink?.propertyMedia
      ) {
        const currentIndex = checkListArray.indexOf(task);
        task = checkListArray.find(
          (nextTask, index) => index > currentIndex && nextTask?.isDone === 0
        );
        if (!task) break; // Break if no more tasks available
      }

      if (task?.taskCode && !currentPage.includes('/share') && !showActivate) {
        const mappedCode = taskCodeMap[task.taskCode] || taskCodeMap.default;

        setTabDAta(mappedCode);
        if (scrollTotabRef.current) {
          scrollTotabRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      }
    }
    setIsMakeanOffer(false);
  }, [
    data,
    realTimeLog,
    checkListArray,
    isActive,
    matchessm,
    offerIconActionST1,
    isMakeanOffer,
    dashboardCounterOfferView,
    showActivate,
    currentPage,
    getBuyerIndividualValue?.PropertyDetails?.timerStatus,
  ]);

  useEffect(() => {
    handleTaskMapping();
  }, [handleTaskMapping]);

  const focusModeActionTabSwitching = () => {
    scrollTotabRef?.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  const history = useHistory();

  const [optionlist, setoptionlist] = useState();
  const [CheckSolicitor, setCheckSolicitor] = useState();
  const [CheckSolicitorlinked, setCheckSolicitorlinked] = useState();
  const [CheckSolicitorlinkedstatus, setCheckSolicitorlinkedstatus] =
    useState();
  const [CheckSolicitorId, setCheckSolicitorId] = useState();
  const [buyerSolicitorDetails, setBuyerSolicitorDetails] = useState();
  const [update, setUpdate] = useState(false);
  const [loadingDue, setLoadingDue] = useState(false);
  const [dataNotFound, setDataNotFound] = useState(false);
  const [datarendered, setDatarendered] = useState(false);

  const commenceBinder = (binderId) => {
    setShowMessage(true);
    setMessagedata({ binderId: binderId });
  };

  const timerfun = () => {
    setTimeout(() => {
      setIsLoading(false);
    }, 10000);
  };

  const [viewContractStatus, setViewContractStatus] = useState('');
  const [contractreviewstatus, setContractreviewstatus] = useState('');
  const groupCall = () => {
    activityfun();
    getChecklistMaster(
      propertyId,
      currentPage,
      userDetail?.primaryUserType
    ).then((res) => {
      if (res?.status == '1') {
        setCheckListArray(res?.TaskList);
        setViewContractStatus(res?.TaskList[2]?.taskStatus);
        setContractreviewstatus(res?.TaskList[3]?.taskStatus);
      } else {
        setCheckListArray([]);
      }
    });
    getlistScheduledInspection(
      propertyId,
      currentPage,
      userDetail?.primaryUserType
    ).then((res) => {
      if (res?.status == '1') {
        setScheduleListArray(res?.scheduledInspection);
        setDisableValues(res?.disableValues);
      } else {
        setScheduleListArray([]);
      }
    });
    getlistPrivateInspection(
      propertyId,
      currentPage,
      userDetail?.primaryUserType
    ).then((res) => {
      if (res?.status == '1') {
        setPrivateListArray(
          res?.scheduledInspection.length > 0
            ? res?.scheduledInspection
            : res?.message
        );
      } else {
        setPrivateListArray(res?.message);
      }
    });
    getlistMakeOffer(propertyId, currentPage, userDetail?.primaryUserType).then(
      (res) => {
        if (res?.status == 1) {
          setMakeOfferListArray(res);
          setLastHighestOffers(res?.LastHighestOffers);
          setLastLatestOffer(res?.LastLatestOffer);
          setConfirmAcceptLog(res?.confirmAcceptLog);
          setDoc66wstatus(res?.status66W);
          setSt1condition(res?.stageOneCondition);
          setSt2condition(res?.stageTwoCondition);
          setIsFirstOffer(res?.isFirstOffer);
          setIsStageTwoRequested(res?.isStageTwoRequested);
          setwWithdrawLeftCount(res?.withdrawLeftCount);
          setIsConditionalChanceCompleted(res?.isConditionalChanceCompleted);
          setArray(res);
        } else {
          setMakeOfferListArray([]);
        }
      }
    );
  };

  const currentUrl = window.location.href;
  const calendarRef = useRef(null);
  const isEnded =
    getBuyerIndividualValue?.PropertyDetails?.timerStatus === 'End';
  const ApicallDueDiligence = () => {
    setLoadingDue(true);
    getDueDelligenceFile(
      propertyId,
      currentUrl,
      userDetail?.primaryUserType
    ).then((res) => {
      setLoadingDue(false);
      if (res?.status == '1') {
        setData(res);
      } else if (res?.status == '-1') {
        setDataNotFound(true);
        setDueDelligencedNotFound(true);
      }
    });
  };

  // useEffect(() => {
  //   ApicallDueDiligence();
  // }, []);

  const sortedScheduleArray =
    scheduleListArray?.length > 0 &&
    [...scheduleListArray].sort((a, b) => {
      const dateTimeA = new Date(a.dateTime);
      const dateTimeB = new Date(b.dateTime);

      return dateTimeA - dateTimeB;
    });
  const [hoverIndex, setHoverIndex] = useState(null);

  const [disableValues, setDisableValues] = useState([]);

  const sortedPrivateArray =
    isArray(privateListArray) && privateListArray?.length > 0
      ? [...privateListArray].sort((a, b) => {
          const dateTimeA = new Date(a.dateTime);
          const dateTimeB = new Date(b.dateTime);
          return dateTimeA - dateTimeB;
        })
      : privateListArray;

  const aibannerfuncs = (condition) => {
    if (condition == true) {
      setTypeofsolicitorpopup('request66w');
      setOpensolicitorpopup(true);
      history.push({
        pathname: history.location.pathname,
        state: { propertyIds: true, isAiMonitorBanner: false },
      });
    }
    if (location.state?.isindividual == true) {
      history.push({
        pathname: history.location.pathname,
        state: {
          propertyIds: true,
          isAiMonitorBanner: false,
          isindividual: false,
        },
      });
    }
  };

  useEffect(() => {
    if (datarendered && !sharedpage) {
      aibannerfuncs(isAiMonitorBanner);
    }
  }, [datarendered]);

  useEffect(() => {
    if (
      location.state?.isAiMonitorBanner == true &&
      location.state?.isindividual == true &&
      !sharedpage
    ) {
      aibannerfuncs(location.state?.isAiMonitorBanner);
    }
  }, [location.state]);

  useEffect(() => {
    groupCall();
    ApicallDueDiligence();
    // groupIt();
  }, [realTimeLog]);

  const renderTabContent = (tabValue) => {
    switch (tabValue) {
      case '1':
        return (
          <div
            style={{
              border: !matchessm && '1px solid #E4E4E4',
              borderRadius: '0px 5px 5px 5px',
              padding: !matchessm ? '20px' : '0px 20px 20px 20px',
            }}
          >
            <Grid sx={{ fontFamily: 'poppins' }}>
              <Grid
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: '5px',
                }}
              >
                <Typography
                  sx={{
                    ...poppins500,
                    fontSize: matchesmd ? '20px' : '24px',
                    whiteSpace: 'nowrap',
                  }}
                >
                  Planned
                </Typography>
                <Typography
                  sx={{
                    border: '1px solid #F0F0F0',
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setPlannedState(!plannedState);
                  }}
                >
                  {!plannedState ? (
                    <ExpandMoreOutlined
                      sx={{ color: '#0065FC', fontSize: 30 }}
                    />
                  ) : (
                    <ExpandLessOutlined
                      sx={{ color: '#0065FC', fontSize: 30 }}
                    />
                  )}
                </Typography>
              </Grid>
              <Collapse in={plannedState}>
                <Grid
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '20px',
                    flexWrap: 'wrap',
                    margin: '30px 0',
                  }}
                >
                  {isArray(sortedPrivateArray) &&
                  sortedPrivateArray?.length > 0 ? (
                    sortedPrivateArray?.map((item, index) => (
                      <Card
                        onMouseOver={() => setHoverIndex(index)}
                        onMouseOut={() => setHoverIndex(null)}
                        key={index}
                        sx={{
                          width: matchessm ? '100%' : '350px',
                          padding: '15px',
                          border: '1px solid #E4E4E4',
                          boxShadow: 'none',
                          background: '#FFFFFF',
                          height: 90,
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Box>
                            <Typography
                              sx={{
                                ...poppins400,
                                fontSize: '20px',
                                color: '#112347',
                              }}
                            >
                              {item?.day}, {item?.date}
                            </Typography>
                          </Box>
                          {item?.status === 'Completed' ? (
                            <Completed />
                          ) : item?.status === 'Pending' ? (
                            <Pending />
                          ) : item?.isConfirmAgent === 1 ? null : (
                            <Pending />
                          )}
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginTop: '5px',
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: '14px',
                              color: '#112347',
                              fontWeight: 400,
                              fontFamily: 'poppins',
                            }}
                          >
                            {item?.time}
                          </Typography>

                          {hoverIndex === index &&
                            item?.status != 'Completed' && (
                              <Box>
                                {item?.insType !== 'Private' ? (
                                  <Tooltip
                                    title="Scheduled Inspection cannot be edited"
                                    arrow
                                  >
                                    <span>
                                      <IconButton
                                        sx={{ color: '#666', padding: '2px' }}
                                        disabled
                                      >
                                        <EditOutlinedIcon />
                                      </IconButton>
                                    </span>
                                  </Tooltip>
                                ) : (
                                  <IconButton
                                    sx={{ color: '#666', padding: '2px' }}
                                    onClick={() => handleEditClick(item)}
                                  >
                                    <EditOutlinedIcon />
                                  </IconButton>
                                )}
                                <IconButton
                                  sx={{ color: '#666', padding: '2px' }}
                                  onClick={() => {
                                    setDeleteInsp(1);
                                    setSelectedIns(item?.inspectionId);
                                    setScheduleItemData({
                                      ...item,
                                      type: item?.insType || item?.type,
                                    });
                                    setOpen(true);
                                  }}
                                >
                                  <DeleteOutlineOutlinedIcon />
                                </IconButton>
                              </Box>
                            )}

                          <Typography
                            sx={{
                              fontSize: '12px',
                              color:
                                item?.status == 'Completed'
                                  ? '#10D35E'
                                  : '#666',
                              fontStyle: 'italic',
                              fontWeight: 500,
                              fontFamily: 'poppins',
                            }}
                          >
                            {item?.status == 'Completed'
                              ? 'Completed'
                              : item?.isConfirmAgent == 1
                              ? null
                              : 'Pending with agent'}
                          </Typography>
                        </Box>
                      </Card>
                    ))
                  ) : (
                    <Typography sx={{ fontFamily: 'poppins' }}>
                      {sortedPrivateArray}
                    </Typography>
                  )}
                </Grid>
              </Collapse>
            </Grid>

            <Grid
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Typography
                sx={{ ...poppins500, fontSize: matchesmd ? '20px' : '24px' }}
              >
                Attend Scheduled Inspection
              </Typography>
              <Typography
                sx={{
                  border: '1px solid #F0F0F0',
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  setAttendState(!attendState);
                  setRequestState(!requestState);
                }}
              >
                {!attendState ? (
                  <ExpandMoreOutlined sx={{ color: '#0065FC', fontSize: 30 }} />
                ) : (
                  <ExpandLessOutlined sx={{ color: '#0065FC', fontSize: 30 }} />
                )}
              </Typography>
            </Grid>
            <Collapse in={attendState}>
              <Grid
                sx={{
                  display: 'flex',
                  flexDirection: matchessm ? 'column' : 'row',
                  flexWrap: 'wrap',
                  gap: matchessm ? '10px' : '20px',
                  maxHeight: '600px', // limit height
                  overflowY: 'auto',
                }}
              >
                {sortedScheduleArray?.length > 0 ? (
                  sortedScheduleArray.map((item) => {
                    const isDisabled = disableValues?.includes(
                      item?.inspectionId
                    );
                    const isPast =
                      currentSydneyDate >
                      dayjs(item?.dateTime).format('YYYY-MM-DD HH:mm:ss');

                    const attendScheduledInspection = () => {
                      if (sharedpage) {
                        setOpenlogin(!openlogin);
                      } else {
                        setScheduleItemData({
                          ...item,
                          type: 'Scheduled',
                        });
                        setInsDate(item?.dateTime);
                        setOpen(true);
                        setConfirmPopupSource('attendInspection');
                      }
                    };

                    const confirmAction = () => {
                      scheduledInspectionRequest();
                      setDisableValues([...disableValues, item?.inspectionId]);
                    };

                    return (
                      <div key={item?.inspectionId}>
                        <Card
                          style={{
                            ...poppins400,
                            backgroundColor:
                              currentSydneyDate <
                              dayjs(item?.dateTime).format(
                                'YYYY-MM-DD HH:mm:ss'
                              )
                                ? '#FFFFFF'
                                : '#F4F6F6',
                            borderRadius: '5px',
                            width: matchessm ? '100%' : '350px',
                            color:
                              currentSydneyDate <
                              dayjs(item?.dateTime).format(
                                'YYYY-MM-DD HH:mm:ss'
                              )
                                ? '#112347'
                                : 'lightgray',
                            border:
                              currentSydneyDate <
                              dayjs(item?.dateTime).format(
                                'YYYY-MM-DD HH:mm:ss'
                              )
                                ? '2px solid #6C2AD2'
                                : '2px solid lightgray',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '15px',
                            marginTop: '20px',
                            border: '1px solid #E4E4E4',
                            textTransform: 'capitalize',
                            cursor:
                              isEnded || isDisabled || isPast
                                ? 'not-allowed'
                                : 'pointer',
                          }}
                          onClick={() => {
                            if (isEnded) return;
                            if (
                              !isDisabled &&
                              currentSydneyDate <
                                dayjs(item?.dateTime).format(
                                  'YYYY-MM-DD HH:mm:ss'
                                )
                            ) {
                              attendScheduledInspection();
                            }
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '5px',
                              alignItems: 'start',
                            }}
                          >
                            <Typography
                              sx={{
                                ...poppins400,
                                textTransform: 'capitalize',
                                fontSize: '20px',
                              }}
                            >
                              {item?.day}, {item?.date}
                            </Typography>
                            {item?.time}
                          </Box>
                          <Box>
                            <CalenderSCGNew fill={isDisabled || isPast} />
                          </Box>
                        </Card>
                      </div>
                    );
                  })
                ) : (
                  <Typography
                    sx={{
                      fontFamily: 'poppins',
                      textAlign: 'center',
                      marginLeft: '20px',
                      color: 'grey',
                    }}
                  >
                    No Inspections Available
                  </Typography>
                )}
              </Grid>
            </Collapse>

            {!matchessm && (
              <Grid
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginTop: '20px',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  setRequestState(!requestState);
                  setAttendState(!attendState);
                }}
              >
                <Grid>
                  <Typography
                    sx={{
                      ...poppins500,
                      fontSize: matchesmd ? '18px' : '24px',
                    }}
                  >
                    Request Private Inspection
                  </Typography>
                </Grid>
                {!matchessm && (
                  <Typography
                    sx={{
                      border: '1px solid #F0F0F0',
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      marginLeft: 'auto',
                    }}
                    onClick={() => setRequestState(!requestState)}
                  >
                    {!requestState ? (
                      <ExpandMoreOutlined
                        sx={{ color: '#0065FC', fontSize: 30 }}
                      />
                    ) : (
                      <ExpandLessOutlined
                        sx={{ color: '#0065FC', fontSize: 30 }}
                      />
                    )}
                  </Typography>
                )}
              </Grid>
            )}
            {matchessm && (
              <Button
                onClick={() => {
                  setRequestState(!requestState);
                }}
                variant="contained"
                style={{
                  fontFamily: 'poppins',
                  fontSize: '20px',
                  fontWeight: 300,
                  color: requestState ? 'white' : '#2A3BD2',
                  border: '1px solid #2A3BD2',
                  background: requestState ? '#6C2AD2' : 'white',
                  padding: '10px',
                  textTransform: 'capitalize',
                  marginTop: '15px',
                  width: '100%',
                }}
              >
                Book Private Inspection
              </Button>
            )}
            <Collapse in={requestState}>
              <Grid
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  marginTop: '40px',
                  gap: '30px',
                  flexWrap: 'wrap',
                }}
              >
                <Grid>
                  <Typography
                    sx={{
                      ...poppins700,
                      fontSize: '20px',
                      marginBottom: '50px',
                    }}
                  >
                    Date Picker
                  </Typography>
                  <Box
                    ref={calendarRef}
                    sx={{ width: matches400 ? '90%' : '100%' }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateCalendar
                        disabled={isEnded}
                        ref={calendarRef}
                        sx={{
                          '& .MuiYearCalendar-root': {
                            width: 'auto !important',
                            maxWidth: '100% !important',
                          },
                          marginTop: '30px',
                        }}
                        disablePast
                        className={classes.calendarContainer}
                        slotProps={slotProps}
                        value={selectedDate}
                        onChange={(date) => {
                          if (isEnded) return;
                          setSelectedDate(date);
                          const formatted = dayjs(date).format('YYYY-MM-DD');
                          setScheduleDate(formatted);
                          setScheduleTime('');
                        }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Grid>
                <Grid>
                  <Grid>
                    <Grid
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                      }}
                    >
                      <Grid sx={{ marginRight: '20px' }}>
                        <Typography
                          sx={{
                            ...poppins700,
                            fontSize: matchessm ? '16px' : '20px',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          Australia Time Zone
                        </Typography>
                      </Grid>
                      <Grid
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                        }}
                      >
                        <img src={Worldnet} style={{ marginRight: '5px' }} />
                        <Typography
                          sx={{
                            ...poppins600,
                            fontSize: matchessm ? '14px' : '16px',
                          }}
                        >
                          {formatTime(currentTime)}
                        </Typography>
                      </Grid>
                    </Grid>
                    {times.map((item) => {
                      const hour = parseInt(item.split(':')[0]);
                      const disabled = hour <= Number(aus2[0]);
                      const getDate = scheduleDate.split('-');
                      const selectedDateNum = Number(getDate[2]);
                      const datttt = new Date();
                      const tdyDate = Number(datttt.getDate());

                      // ADD THIS LINE - Check if this time is selected
                      const isSelectedTime =
                        scheduleTime ===
                        moment(item, ['h:mm A']).format('HH:mm:ss');

                      return (
                        <Button
                          sx={{
                            backgroundColor: isSelectedTime
                              ? '#6C2AD2'
                              : '#FFFFFF', // Purple highlight when selected
                            borderRadius: '5px',
                            ...poppins700,
                            fontSize: '20px',
                            color: isSelectedTime ? '#FFFFFF' : '#6C2AD2', // White text when selected
                            minWidth: '314px',
                            whiteSpace: 'nowrap',
                            height: '56px',
                            border: isSelectedTime // Purple border when selected
                              ? '2px solid #6C2AD2'
                              : scheduleDate?.length > 0
                              ? '2px solid #6C2AD2' // Purple border when date picked
                              : '2px solid grey', // Grey border when no date
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginTop: '20px',
                            cursor: 'pointer',
                            pointerEvents:
                              disabled && selectedDateNum == tdyDate
                                ? 'none'
                                : 'auto',
                            opacity:
                              disabled && selectedDateNum == tdyDate && 0.4,
                            '&:hover': {
                              backgroundColor: isSelectedTime ? '#6C2AD2' : '',
                            },
                          }}
                          disabled={scheduleDate?.length > 0 ? false : true}
                          onClick={() => {
                            var dt = moment(item, ['h:mm A']).format(
                              'HH:mm:ss'
                            );
                            setScheduleTime(dt);
                            let obj = {
                              day: moment(scheduleDate).format('dddd'),
                              date:
                                moment(scheduleDate).format('MMMM') +
                                ' ' +
                                moment(scheduleDate).format('DD'),
                              time: item,
                              dateTime:
                                dt +
                                ' ' +
                                moment(scheduleDate).format('DD-MM-YYYY'),
                              type: 'Private',
                            };
                            setScheduleItemData(obj);
                            setOpen(true);
                            setConfirmPopupSource('privateInspection');
                          }}
                        >
                          {item}
                        </Button>
                      );
                    })}
                  </Grid>
                </Grid>
              </Grid>
            </Collapse>
          </div>
        );
      case '2':
        return (
          <div style={{ padding: '0px' }}>
            <ViewContact
              groupCall={groupCall}
              requesttoview={requesttoview}
              viewContractStatus={viewContractStatus}
              setRequesttoview={setRequesttoview}
              contractreviewstatus={contractreviewstatus}
              setOpensolicitorpopup={setOpensolicitorpopup}
              setTypeofsolicitorpopup={setTypeofsolicitorpopup}
            />
          </div>
        );
      case '3':
        return (
          <div>
            <DueDiligence
              ApicallDueDiligence={ApicallDueDiligence}
              getBuyerIndividualValue={getBuyerIndividualValue}
              loadingDue={loadingDue}
              setLoadingDue={setLoadingDue}
              dataNotFound={dataNotFound}
              setDataNotFound={setDataNotFound}
              data={data}
              setData={setData}
              groupCall={groupCall}
              openlogin={openlogin}
              setOpenlogin={setOpenlogin}
              sharedpage={sharedpage}
            />
          </div>
        );
      case '4':
        return (
          <div ref={makeOfferRef}>
            <MakeOffers
              isAuction={isAuction}
              auctionDetails={auctionDetails}
              setTabDAta={setTabDAta}
              setNewTabData={setNewTabData}
              setShowPropertyTimer={setShowPropertyTimer}
              offerHistoryState={offerHistoryState}
              tabData={tabData}
              hideOthers={hideOthers}
              SetHideOthers={SetHideOthers}
              hideActivateTrade={hideActivateTrade}
              setHideActivateTrade={setHideActivateTrade}
              makeOfferListArray={makeOfferListArray}
              lastHighestOffers={lastHighestOffers}
              setLastHighestOffers={setLastHighestOffers}
              lastLatestOffer={lastLatestOffer}
              withdrawLeftCount={withdrawLeftCount}
              array={array}
              setShowActivateTrade={setShowActivateTrade}
              makeOfferRef={makeOfferRef}
              stage={getBuyerIndividualValue?.PropertyDetails?.stage}
              groupIt={groupIt}
              groupCall={groupCall}
              getlistMakeOffer={getlistMakeOffer}
              getBuyerIndividualValue={getBuyerIndividualValue}
              confirmAcceptLog={confirmAcceptLog}
              setOpenlogin={setOpenlogin}
              openlogin={openlogin}
              sharedpage={sharedpage}
              doc66wstatus={doc66wstatus}
              st1condition={st1condition}
              st2condition={st2condition}
              isFirstOffer={isFirstOffer}
              setDontallowtooffer={setDontallowtooffer}
              offersOnly={offersOnly}
              setOffersOnly={setOffersOnly}
              setOpenFocusDialog={setOpenFocusDialog}
              isStageTwoRequested={isStageTwoRequested}
              setIsStageTwoRequested={setIsStageTwoRequested}
              checkListArray={checkListArray}
              uploadDoc={uploadDoc}
              directcomm={directcomm}
              realTimeLog={realTimeLog}
              isConditionalChanceCompleted={isConditionalChanceCompleted}
              setTypeofsolicitorpopup={setTypeofsolicitorpopup}
              setOpensolicitorpopup={setOpensolicitorpopup}
            />
          </div>
        );
    }
  };

  const getColor = (status, taskName) => {
    if (status == 'Processing') {
      return '#F39800';
    }
    // if (taskName == 'Deposit Payment' && status == 'Processed') {
    //   return 'grey';
    // }
    if (status === 'E-sign Requested') {
      return 'grey';
    }
    if (status === 'E-sign Registered Successfully') {
      return '#10D35E';
    }
    if (status === 'E-sign Completed') {
      return '#10D35E';
    }
    if (status === 'Pending for E-sign') {
      return '#F39800';
    }
    if (status === 'Pending Buyer Signature') {
      return '#F39800';
    }
    if (status === 'Pending') {
      return '#F39800';
    }
    if (status === 'Reviewed') {
      return '#10D35E';
    }
    if (status === 'Completed') {
      return '#10D35E';
    }
    if (status === 'Approved') {
      return '#34b7eb';
    }
    if (status === 'Action Required') {
      return '#F93939';
    }
    if (status === 'In Progress') {
      return '#F39800';
    }
    if (status === 'Forwarded') {
      return '#10D35E';
    } else {
      return 'grey';
    }
  };

  const [listScheduleLoader, setListScheduleLoader] = useState(false);
  const [insDate, setInsDate] = useState('');

  const scheduledInspectionRequest = (dt) => {
    setListScheduleLoader(true);
    let input;
    if (scheduleItemData?.type === 'Scheduled') {
      input = {
        insDateTime: insDate,
        propertyId: propertyId,
        insType: scheduleItemData?.type,
        insStatus: 'Scheduled',
        insId: scheduleItemData?.inspectionId,
        privateInsId: selecdtedInsp,
        isDelete: deleteInsp,
      };
    } else {
      input = {
        propertyId: propertyId,
        insType: 'Private',
        insDateTime: scheduleDate + ' ' + scheduleTime,
        insStatus: 'Scheduled',
        insId: '0',
        privateInsId: selecdtedInsp,
        isDelete: deleteInsp,
      };
    }

    scheduleInspection(input)
      .then((res) => {
        if (res?.status == '1') {
          setListScheduleLoader(false);

          // Clear all states on success
          handleCancelEdit();

          setOpen(false);
          Swal.fire({
            title: res?.heading ? res?.heading : 'Success',
            text: res?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'success',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (result.isConfirmed) {
              setOpen(false);
            }
          });
          groupCall();
          groupIt();
        } else {
          setListScheduleLoader(false);
          // Keep error handling same
          handleCancelEdit();
          setOpen(false);
          Swal.fire({
            title: res?.heading ? res?.heading : 'Error',
            text: res?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'error',
            confirmButtonText: 'Close',
          });
        }
      })
      .catch(() => setListScheduleLoader(false));
  };
  useEffect(() => {}, [showTick, isLoading]);
  const getColorLite = (value) => {
    let color = 'rgba(243, 152, 0, 1)';
    if (value === 'Accepted') {
      color = 'rgba(16, 211, 94, 1)';
    }
    if (value === 'Rejected') {
      color = 'rgba(249, 57, 57, 1)';
    }
    if (value === 'Pending') {
      color = '#F39800';
    }
    if (value === 'Counter Received') {
      color = 'rgba(255, 0, 255, 1)';
    }

    if (value === 'Private Offer') {
      color = '#4CA4D6';
    }
    return color;
  };
  useEffect(() => {
    if (isLoading66w || loading || listScheduleLoader || isLoadingSign) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [isLoading66w, loading, listScheduleLoader, isLoadingSign]);

  const moxoapis_esign = (res) => {
    if (isNotEmptyArray(res?.data?.dataForRequestEsign))
      Moxoseparationinlisting(
        'dataForRequestEsign',
        res?.data?.dataForRequestEsign
      ); //1
  };

  // request e-sign post api function
  const handleSignContract = (name, surName) => {
    setIsLoadingSign(true);
    const input = {
      propertyId: propertyId,
    };
    postApiCall(BUYER_REQUEST_ESIGN, input)
      .then((res) => {
        if (res?.data?.status == 1) {
          groupCall();
          groupIt();
          moxoapis_esign(res);
          Swal.fire({
            title: res?.data?.heading ? res?.data?.heading : 'Success',
            html: `You have submitted a request to 
            <span style="font-weight: 550; font-family: 'Poppins'; color: #666666;"> ${name} ${surName}</span> 
            to prepare the contract of sale for e-Signing.`,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'success',
            confirmButtonText: 'Close',
            allowOutsideClick: false,
          });
          setIsLoadingSign(false);
          setOpenBoxSign(false);
        } else {
          Swal.fire({
            title: res?.data?.heading ? res?.data?.heading : 'Error',
            text: res?.data?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'error',
            confirmButtonText: 'Close',
          });
          setIsLoadingSign(false);
          setOpenBoxSign(false);
        }
      })
      .catch((res) => {
        Swal.fire({
          title: res?.data?.heading ? res?.data?.heading : 'Error',
          text: res?.data?.message,
          showDenyButton: false,
          showCancelButton: false,
          icon: 'error',
          confirmButtonText: 'Close',
        });
        setIsLoadingSign(false);
      });
  };

  const openMessage = (buyerBinderID) => {
    setShowMessage(true);
    setMessagedata({ binderId: buyerBinderID });
  };

  const uploadDoc = () => {
    setUploadDocuments(true);
  };

  //DueDelligenceFile Api Call And find empty val to hide checklist
  const [dueDelligencedNotFound, setDueDelligencedNotFound] = useState(false);

  const Apicall = () => {
    getDueDelligenceFile(
      propertyId,
      currentPage,
      userDetail?.primaryUserType
    ).then((res) => {
      if (res?.status == '-1') {
        setDueDelligencedNotFound(true);
      }
    });
  };

  // useEffect(() => {
  //   Apicall();
  // }, []);

  // Restore states from localStorage on page load
  useEffect(() => {
    const savedDate = localStorage.getItem('inspectionDate');
    const savedTime = localStorage.getItem('inspectionTime');
    const savedItem = localStorage.getItem('inspectionItem');
    const savedEditInsp = localStorage.getItem('editInsp');
    const savedSelectedIns = localStorage.getItem('selectedIns');

    if (savedDate) setScheduleDate(savedDate);
    if (savedTime) setScheduleTime(savedTime);
    if (savedItem) setScheduleItemData(JSON.parse(savedItem));
    if (savedEditInsp) setEditInsp(Number(savedEditInsp));
    if (savedSelectedIns) setSelectedIns(Number(savedSelectedIns));
  }, []);

  const { isScrolling } = useContext(PropertyContext);

  const dialogContentRef = useRef(null);

  const handleScrollToTop = () => {
    if (dialogContentRef.current) {
      dialogContentRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  const animationRef = useRef(null);

  useEffect(() => {
    const element = animationRef.current;
    if (element) {
      // Stop the animation after 3 seconds
      setTimeout(() => {
        element.style.animation = ''; // Removes the animation
      }, 5000); // 3000ms = 3 seconds
    }
  }, []);

  const variance =
    getBuyerIndividualValue?.PropertyDetails?.offerStatus?.variance;
  const statusInfo =
    getBuyerIndividualValue?.PropertyDetails?.offerStatus?.status;
  const offerstatus =
    getBuyerIndividualValue?.PropertyDetails?.offerStatus?.priceCounter;
  const imageEndRef = useRef(null);

  const handleContainerScroll = () => {
    const container = marketScrollRef.current;
    const anchor = imageEndRef.current;
    if (!container || !anchor) return;

    const containerTop = container.getBoundingClientRect().top;
    const anchorTop = anchor.getBoundingClientRect().top;

    const reachedTop = anchorTop <= containerTop;

    setIsStickyAddress((prev) => {
      if (prev !== reachedTop) return reachedTop;
      return prev;
    });

    setIsSticky((prev) => {
      if (prev !== reachedTop) return reachedTop;
      return prev;
    });
  };

  useEffect(() => {
    const container = marketScrollRef.current;
    if (!container) return;

    container.addEventListener('scroll', handleContainerScroll);
    handleContainerScroll(); // run once

    return () => container.removeEventListener('scroll', handleContainerScroll);
  }, []);

  return (
    <>
      <Grid
        item
        sx={{
          marginLeft: matchessm
            ? '0%'
            : currentPage.includes('/share')
            ? '5%'
            : '8%',
          width: matchessm
            ? '100%'
            : currentPage.includes('/share') && !matchesxlIsSticky
            ? matches1281
              ? '100%'
              : '70%'
            : '70%',
          marginTop: !matches900 ? '50px' : '20px',
        }}
      >
        {!matcheslgIsSticky && highestOfferBox && (
          <Collapse in={highestOfferBox}>
            <Card
              sx={{
                position: 'absolute',
                top: matchessm ? '530px' : matchesmd ? '630px' : '1050px',
                right: 0,
                background: 'white',
                zIndex: 1,
                height: '100vh',
                overflow: 'auto',
              }}
            >
              <Box
                onClick={() => setHighestOfferBox(!highestOfferBox)}
                sx={{ cursor: 'pointer', margin: '20px 10px' }}
              >
                <Expand />
              </Box>
              <HighestOffer1
                isSticky={isSticky}
                matchesxl={matchesxl}
                showActivateTrade={showActivateTrade}
                isStickyAddress={isStickyAddress}
                blurComp={blurComp}
                isStickyTimer={isStickyTimer}
                confirmAcceptLog={confirmAcceptLog}
                getBuyerIndividualValue={getBuyerIndividualValue}
                dateupdated={dateupdated}
                userDetail={userDetail}
                setShowActivateTrade={setShowActivateTrade}
                setHideActivateTrade={setHideActivateTrade}
                setTabDAta={setTabDAta}
                onShowChat={onShowChat}
                activityupdate={activityupdate}
                sharedpage={sharedpage}
              />
            </Card>
          </Collapse>
        )}
        <Commonfile
          getBuyerIndividualValue={getBuyerIndividualValue}
          matchessm={matchessm}
          openShare={openShare}
          matchesmd={matchesmd}
          handleClickOpen={handleClickOpen}
          matches500={matches500}
          handleFollowClick={handleFollowClick}
          matcheslgIsSti={matcheslgIsSti}
          isFollowLoading={isFollowLoading}
          sharedpage={sharedpage}
          openlogin={openlogin}
          setOpenlogin={setOpenlogin}
          handleClose={handleClose}
          matcheslgIsSticky={matcheslgIsSticky}
          matcheslgup={matcheslgup}
          highestOfferBox={highestOfferBox}
          setHighestOfferBox={setHighestOfferBox}
          setHideActivateTrade={setHideActivateTrade}
          setShowActivateTrade={setShowActivateTrade}
          tradeassist={true}
        />
        <Grid
          id="myGrid"
          container
          className="market-content"
          sx={{ height: 'auto', maxHeight: '4000px' }}
        >
          <Stack container spacing={'2'} sx={{ width: '100%' }}>
            <Grid
              item
              sx={{
                display: 'flex',
                width: '100%',
                gap: '10px',
              }}
            >
              <Grid
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px',
                  overflowY: 'scroll',
                  '-webkit-scrollbar': {
                    display: 'none',
                  },
                  '-ms-overflow-style': 'none' /* IE and Edge */,
                  'scrollbar-width': 'none',
                }}
              >
                <Stack>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontStyle: 'normal !important',
                      fontWeight: '600 !important',
                      fontSize: matchessm ? '24px' : '32px',
                      color: '#112347',
                      textAlign: 'left',
                    }}
                  >
                    Property Hub
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
            <Grid sx={{ overflow: 'hidden' }}>
              <BuyerIndividualBanners
                setTabDAta={setTabDAta}
                makeOfferRef={makeOfferRef}
                isStickyTimerStage={isStickyTimerStage}
                stickyAnchorTimerRef={stickyAnchorTimerRef}
                getBuyerIndividualValue={getBuyerIndividualValue}
                stageLoader={stageLoader}
                stageTwoViewFunc={stageTwoViewFunc}
                hoverEffect={hoverEffect}
                isStickyAddress={isStickyAddress}
                setIsHovered={setIsHovered}
                isHovered={isHovered}
                isSticky={isSticky}
                showActivateTrade={showActivateTrade}
                sharedpage={sharedpage}
                setOpenlogin={setOpenlogin}
                openlogin={openlogin}
                handleMouseLeave={handleMouseLeave}
                handleClick={handleClick}
                isDialogOpen={isDialogOpen}
                setDialogOpen={setDialogOpen}
                anchorEl={anchorEl}
                setAnchorEl={setAnchorEl}
                scrollTotabRef={scrollTotabRef}
                groupIt={groupIt}
                groupCall={groupCall}
                st1condition={st1condition}
                setOpensolicitorpopup={setOpensolicitorpopup}
                setTypeofsolicitorpopup={setTypeofsolicitorpopup}
              />
            </Grid>
            <Stack
              direction={'row'}
              sx={{
                width: '100%',
                justifyContent: 'space-between',
                marginTop: '30px',
                marginBottom: '20px',
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins !important',
                  fontStyle: 'normal !important',
                  fontWeight: '500 !important',
                  fontSize: matchessm ? '20px' : '24px',
                  color: '#112347',
                  paddingTop: '35px',
                }}
              >
                {' '}
                Your Offer Status
              </Typography>
            </Stack>

            <div
              ref={animationRef}
              style={{
                marginTop: '25px',
                borderRadius: '5px',
                borderWidth: '1px',
                animation: 'backgroundAnimation   0.3s infinite',
              }}
            >
              <Stack
                sx={{
                  minHeight: '96px',
                  border: '0.5px solid #E4E4E4',
                  padding: '10px',
                  display: 'flex',
                  borderRadius: '5px',
                  borderWidth: '1px',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                {getBuyerIndividualValue?.PropertyDetails?.offerStatus
                  ?.price !== '' ? (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: matchessm ? 'column' : 'row',
                      gap: matchessm && '20px',
                      alignItems: 'center',
                      justifyContent: 'space-around',
                      width: '100%',
                    }}
                  >
                    <Grid item>
                      <Typography
                        sx={{
                          borderRadius: '54px',
                          color: 'red',
                          width: 'fit-content',
                          whiteSpace: 'nowrap',
                          padding: '6px 14px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                          border: `1px solid ${
                            getBuyerIndividualValue?.PropertyDetails
                              ?.offerStatus?.status == 'Accepted'
                              ? 'rgba(16, 211, 94, 1)'
                              : getBuyerIndividualValue?.PropertyDetails
                                  ?.offerStatus?.status == 'Rejected'
                              ? 'rgba(249, 57, 57, 1)'
                              : getBuyerIndividualValue?.PropertyDetails
                                  ?.offerStatus?.status == 'Pending'
                              ? '#F39800'
                              : getBuyerIndividualValue?.PropertyDetails
                                  ?.offerStatus?.status == 'Counter Received'
                              ? 'rgba(255, 0, 255, 1)'
                              : getBuyerIndividualValue?.PropertyDetails
                                  ?.offerStatus?.status == 'Private Offer'
                              ? '#4CA4D6'
                              : 'rgba(243, 152, 0, 1)'
                          }`,
                        }}
                      >
                        <Typography>
                          <WarningLite
                            color={getColorLite(
                              getBuyerIndividualValue?.PropertyDetails
                                ?.offerStatus?.status
                            )}
                          />
                        </Typography>
                        <Typography
                          sx={{
                            ...poppins300,
                            fontSize: '16px',
                            color:
                              getBuyerIndividualValue?.PropertyDetails
                                ?.offerStatus?.status == 'Accepted'
                                ? 'rgba(16, 211, 94, 1)'
                                : getBuyerIndividualValue?.PropertyDetails
                                    ?.offerStatus?.status == 'Rejected'
                                ? 'rgba(249, 57, 57, 1)'
                                : getBuyerIndividualValue?.PropertyDetails
                                    ?.offerStatus?.status == 'Pending'
                                ? 'orange'
                                : getBuyerIndividualValue?.PropertyDetails
                                    ?.offerStatus?.status == 'Counter Received'
                                ? 'rgba(255, 0, 255, 1)'
                                : getBuyerIndividualValue?.PropertyDetails
                                    ?.offerStatus?.status == 'Private Offer'
                                ? '#4CA4D6'
                                : 'rgba(243, 152, 0, 1)',
                          }}
                        >
                          {getBuyerIndividualValue?.PropertyDetails?.offerStatus
                            ?.status || '-'}
                        </Typography>
                      </Typography>
                    </Grid>
                    {!(
                      getBuyerIndividualValue?.PropertyDetails?.offerStatus
                        ?.priceCounter &&
                      getBuyerIndividualValue?.PropertyDetails?.offerStatus
                        ?.variance === null
                    ) && (
                      <Grid item sx={{ textAlign: 'center' }}>
                        <Box>
                          <Typography
                            sx={{
                              ...poppins600,
                              fontSize: '32px',
                              color: '#112347',
                            }}
                          >
                            {getBuyerIndividualValue?.PropertyDetails
                              ?.offerStatus?.price || '-'}
                          </Typography>
                        </Box>
                        <Box>
                          <Typography
                            sx={{
                              ...poppins400,
                              fontSize: '12px',
                              color: 'rgba(17, 35, 71, 0.5)',
                            }}
                          >
                            Last Updated :
                          </Typography>
                          <Typography
                            sx={{
                              ...poppins400,
                              fontSize: '12px',
                              color: '#112347',
                            }}
                          >
                            {offerStatusLastUpdated || '-'}
                          </Typography>
                        </Box>
                      </Grid>
                    )}
                    {statusInfo !== 'Offer Updated' &&
                      variance !== null &&
                      variance !== undefined &&
                      offerstatus != null && (
                        <Grid item sx={{ textAlign: 'center' }}>
                          {Math.round(variance) < 0 ? (
                            <Typography
                              sx={{
                                ...poppins500,
                                fontSize: matches400 ? '10px' : '20px',
                                color: '#F93939',
                                whiteSpace: 'nowrap',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                              }}
                            >
                              {Math.round(Math.abs(variance))}%
                              <Box marginBottom={1.5}>
                                <DownArrowRed
                                  width={matches400 ? '8' : '12'}
                                  height={matches400 ? '16' : '26'}
                                />
                              </Box>
                            </Typography>
                          ) : Math.round(variance) === 0 ? (
                            <Typography
                              sx={{
                                ...poppins500,
                                fontSize: matches400 ? '10px' : '40px',
                                color: 'rgba(16, 211, 94, 1)',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              <Box
                                component="span"
                                sx={{ fontFamily: 'Arial' }}
                              >
                                ≈
                              </Box>
                            </Typography>
                          ) : (
                            <Typography
                              sx={{
                                ...poppins500,
                                fontSize: matches400 ? '10px' : '20px',
                                color: 'rgba(16, 211, 94, 1)',
                                whiteSpace: 'nowrap',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '2px',
                              }}
                            >
                              {Math.round(variance)}%
                              <Box marginBottom={1.5}>
                                <Uparrow
                                  width={matches400 ? '8' : '12'}
                                  height={matches400 ? '16' : '26'}
                                />
                              </Box>
                            </Typography>
                          )}
                        </Grid>
                      )}

                    {getBuyerIndividualValue?.PropertyDetails?.offerStatus
                      ?.status != 'Offer Updated' &&
                      getBuyerIndividualValue?.PropertyDetails?.offerStatus
                        ?.priceCounter && (
                        <Grid item sx={{ textAlign: 'center' }}>
                          <Box>
                            <Typography
                              sx={{
                                ...poppins600,
                                fontSize: '32px',
                                color: '#112347',
                              }}
                            >
                              {getBuyerIndividualValue?.PropertyDetails
                                ?.offerStatus?.priceCounter || '-'}
                            </Typography>
                          </Box>
                          <Box>
                            <Typography
                              sx={{
                                ...poppins400,
                                fontSize: '12px',
                                color: 'rgba(17, 35, 71, 0.5)',
                              }}
                            >
                              Last Updated :
                            </Typography>
                            <Typography
                              sx={{
                                ...poppins400,
                                fontSize: '12px',
                                color: '#112347',
                              }}
                            >
                              {lastUpdatedCounter || '-'}
                            </Typography>
                          </Box>
                        </Grid>
                      )}
                    <Grid item>
                      <BuyerManageOffer
                        setOpenBox={setOpenBox}
                        openBox={openBox}
                        setTabDAta={setTabDAta}
                        Makeoffer={Makeoffer}
                        propertyId={propertyId}
                        getBuyerIndividualValue={getBuyerIndividualValue}
                        confirmBuyerOffer={confirmBuyerOffer}
                        groupIt={groupIt}
                        groupCall={groupCall}
                        setDontallowtooffer={setDontallowtooffer}
                        sharedpage={sharedpage}
                        handleMakeOfferClick={handleMakeOfferClick}
                        setOfferHistoryState={setOfferHistoryState}
                        setNewTabData={setNewTabData}
                        SetHideOthers={SetHideOthers}
                        setShowPropertyTimer={setShowPropertyTimer}
                        handlemakeoffertab={handlemakeoffertab}
                        setOpensolicitorpopup={setOpensolicitorpopup}
                        setTypeofsolicitorpopup={setTypeofsolicitorpopup}
                      />
                    </Grid>
                  </div>
                ) : (
                  <Grid
                    container
                    sx={{
                      display: 'flex',
                      flexDirection: matchessm ? 'column' : 'row',
                      gap: matchessm && '10px',
                      alignItems: 'center',
                      justifyContent: 'space-around',
                    }}
                  >
                    <Grid
                      item
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '200px',
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="error"
                        sx={{
                          borderRadius: '64px',
                          padding: '5px 10px 5px 10px',
                          fontWeight: '300',
                          color: 'rgba(102, 102, 102, 1)',
                          fontSize: '16px',
                          border: '1px solid rgba(102, 102, 102, 1)',
                          fontFamily: 'poppins',
                          textTransform: 'none',
                          gap: '10px',
                          alignItems: 'center',
                        }}
                      >
                        <Alert />
                        You have made no offers
                      </Button>
                    </Grid>
                    <Grid
                      item
                      alignItems="center"
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: matchessm ? '100%' : '50%',
                        textAlign: 'center',
                      }}
                    >
                      <Grid
                        sx={{
                          marginTop: matches1500 ? '10px' : '0px',
                          marginBottom: matches1500 ? '10px' : '0px',
                        }}
                      >
                        <Typography
                          sx={{
                            ...poppins300,
                            fontSize: matchessm ? '16px' : '20px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                          }}
                        >
                          <Fireemoji height={25} width={25} />
                          Currently
                          <Typography
                            component="span"
                            sx={{
                              ...poppins600,
                              fontSize: '18px',
                              color: '#000',
                              marginX: '2px',
                            }}
                          >
                            {
                              getBuyerIndividualValue?.PropertyDetails
                                ?.offerStatus?.InterestCount
                            }
                          </Typography>
                          active buyer
                          {getBuyerIndividualValue?.PropertyDetails?.offerStatus
                            ?.InterestCount !== 1
                            ? 's'
                            : ''}{' '}
                          showing Interest in this property
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      onClick={() => {
                        if (sharedpage) {
                          setOpenlogin(!openlogin);
                        }
                      }}
                    >
                      <Select
                        id="optionlist"
                        open={selectOpen}
                        onOpen={() => setSelectOpen(true)}
                        onClose={() => setSelectOpen(false)}
                        disabled={
                          (getBuyerIndividualValue?.PropertyDetails?.isWinner ==
                            1 &&
                            getBuyerIndividualValue?.PropertyDetails
                              ?.isWinnerId == userId &&
                            getBuyerIndividualValue?.PropertyDetails
                              ?.timerStatus == 'End') ||
                          (getBuyerIndividualValue?.PropertyDetails
                            ?.timerStatus == 'Start' &&
                            !sharedpage)
                            ? false
                            : true
                        }
                        sx={{
                          ...poppins500,
                          fontSize: '12px',
                          fontColor: '#112347',
                          border:
                            (getBuyerIndividualValue?.PropertyDetails
                              ?.isWinner == 1 &&
                              getBuyerIndividualValue?.PropertyDetails
                                ?.isWinnerId == userId &&
                              getBuyerIndividualValue?.PropertyDetails
                                ?.timerStatus == 'End') ||
                            (getBuyerIndividualValue?.PropertyDetails
                              ?.timerStatus == 'Start' &&
                              !sharedpage)
                              ? '1px solid #6C2AD2'
                              : 'none',
                          boxShadow:
                            (getBuyerIndividualValue?.PropertyDetails
                              ?.isWinner == 1 &&
                              getBuyerIndividualValue?.PropertyDetails
                                ?.isWinnerId == userId &&
                              getBuyerIndividualValue?.PropertyDetails
                                ?.timerStatus == 'End') ||
                            (getBuyerIndividualValue?.PropertyDetails
                              ?.timerStatus == 'Start' &&
                              !sharedpage)
                              ? 'noen'
                              : '0px 1px 4px rgba(0, 0, 0, 0.15)',
                          '.MuiOutlinedInput-notchedOutline': { border: 0 },
                          width: '100px',
                          height: '30px',
                          borderRadius: '6px',
                        }}
                        className={classes.disabledSelect}
                        value={action}
                        displayEmpty
                      >
                        <MenuItem
                          value={'Action'}
                          sx={{
                            ...poppins500,
                            fontSize: '12px',
                            color: '#112347',
                            display: 'none',
                          }}
                        >
                          Action
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            setSelectOpen(false);
                            setOpenBox(!openBox);
                          }}
                          disabled={
                            getBuyerIndividualValue?.PropertyDetails
                              ?.offerStatus?.price === ''
                          }
                          value={10}
                          sx={{
                            ...poppins500,
                            fontSize: '12px',
                            color: '#112347',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Viewoffer />
                          <span style={{ marginRight: '8px' }} />
                          View Offer Details
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            setSelectOpen(false);
                            handlemakeoffertab();
                          }}
                          value={20}
                          sx={{
                            ...poppins500,
                            fontSize: '12px',
                            color: '#112347',
                            alignItems: 'center',
                            justifyContent: 'left',
                          }}
                        >
                          <Makeoffer />
                          <span style={{ marginRight: '8px' }} />
                          Make Offer
                        </MenuItem>
                      </Select>
                    </Grid>
                  </Grid>
                )}
              </Stack>
              <style>
                {`
      @keyframes backgroundAnimation {
      
        50% { background-color:${
          getBuyerIndividualValue?.PropertyDetails?.offerStatus?.historyCode ===
          'BuyerAcc001'
            ? 'inherit'
            : getBuyerIndividualValue?.PropertyDetails?.offerStatus?.status ==
              'Accepted'
            ? '#f0f0f0'
            : getBuyerIndividualValue?.PropertyDetails?.offerStatus?.status ==
              'Rejected'
            ? '#f0f0f0'
            : getBuyerIndividualValue?.PropertyDetails?.offerStatus?.status ==
              'Counter Received'
            ? '#f0f0f0'
            : ''
        }`}
              </style>
            </div>
          </Stack>
          <Grid
            container
            sx={{
              flexDirection: 'column',
              marginTop: '80px',
              gap: '30px',
            }}
          >
            <Grid item>
              <Typography
                sx={{
                  ...poppins500,
                  fontSize: matchessm ? '20px' : '24px',
                  color: '#112347',
                }}
              >
                Checklist
              </Typography>
            </Grid>
            {/* demo checklist */}
            <Grid
              item
              sx={{
                borderRadius: '5px',
                border: '0.5px solid #E4E4E4',
                overflow: 'auto',
                width: '100%',
              }}
            >
              <CheckLists
                groupCall={groupCall}
                ApicallDueDiligence={ApicallDueDiligence}
                checkListArray={checkListArray}
                getSteps={getSteps}
                getBuyerIndividualValue={getBuyerIndividualValue}
                getBuyerIndividualData={getBuyerIndividualData}
                data={data}
                dueDelligencedNotFound={dueDelligencedNotFound}
                checkListPop={checkListPop}
                getColor={getColor}
                sharedpage={sharedpage}
                setOpenlogin={setOpenlogin}
                userId={userId}
                openlogin={openlogin}
                setTabDAta={setTabDAta}
                handleMakeOfferClick={handleMakeOfferClick}
                setNewTabData={setNewTabData}
                action={action}
                uploadDoc={uploadDoc}
                openMessage={openMessage}
                commenceBinder={commenceBinder}
                setPaymentPop={setPaymentPop}
                setOpenBoxSign={setOpenBoxSign}
                depositPaymentBuyer={depositPaymentBuyer}
                setDepositPaymentBuyer={setDepositPaymentBuyer}
                signContract={signContract}
                setSignContract={setSignContract}
                contractReviewed={contractReviewed}
                setContractReviewed={setContractReviewed}
                viewContractBuyer={viewContractBuyer}
                setViewContractBuyer={setViewContractBuyer}
                dueDiligence={dueDiligence}
                setDueDiligence={setDueDiligence}
                propertyInspected={propertyInspected}
                setPropertyInspected={setPropertyInspected}
                classes={classes}
                showActivate={showActivate}
                tabData={tabData}
                setRequesttoview={setRequesttoview}
                isAuction={isAuction}
                auctionDetails={auctionDetails}
                userDetail={userDetail}
                setOpensolicitorpopup={setOpensolicitorpopup}
                setTypeofsolicitorpopup={setTypeofsolicitorpopup}
              />
              <Popover
                id={idCheck}
                open={openCheck}
                anchorEl={anchorEl}
                onClick={handleCloseCheck}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
              >
                <Grid
                  container
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '15px',
                    maxWidth: '540px',
                    marginTop: '-20px',
                  }}
                >
                  <Grid
                    sx={{
                      padding: '0 30px',
                      marginTop: '50px',
                      color: '#6C2AD2 !important',
                      fontFamily: 'poppins',
                      fontSize: '16px',
                      fontWeight: 500,
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px', // Adds space between the icon and the name
                      }}
                    >
                      <Typography
                        sx={{
                          color: '#6C2AD2 !important', // Adding `!important` to override any conflicting styles
                          fontFamily: 'poppins',
                          fontSize: '8px',
                          fontWeight: 500,
                        }}
                      >
                        {popoverStatusName}
                      </Typography>
                      {icons == '66w Certificate' ? 's66W Certificate' : icons}
                    </Box>
                  </Grid>
                  <Grid sx={{ padding: '0 30px' }}>
                    <Typography
                      sx={{
                        color: '#112347',
                        fontFamily: 'poppins',
                        fontSize: '14px',
                        fontWeight: 300,
                      }}
                    >
                      {popoverStatusList}
                    </Typography>
                  </Grid>
                  {wList1 != '' && (
                    <Grid sx={{ padding: '0 30px' }}>
                      <Typography
                        sx={{
                          color: '#112347',
                          fontFamily: 'poppins',
                          fontSize: '14px',
                          fontWeight: 300,
                        }}
                      >
                        {wList1}
                      </Typography>
                    </Grid>
                  )}
                  {wList1 != '' && (
                    <Grid sx={{ padding: '0 30px' }}>
                      <Typography
                        sx={{
                          color: '#112347',
                          fontFamily: 'poppins',
                          fontSize: '14px',
                          fontWeight: 300,
                        }}
                      >
                        <span style={{ fontWeight: 600 }}>71%</span>
                        {wList2}
                      </Typography>
                    </Grid>
                  )}
                  <Divider />
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            ...poppins400,
                            fontSize: '14px',
                            borderBottom: 'none',
                          }}
                        >
                          Status
                        </TableCell>
                        <TableCell
                          sx={{
                            ...poppins400,
                            fontSize: '14px',
                            borderBottom: 'none',
                          }}
                        >
                          Last Updated
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell width={'50%'} sx={{ borderBottom: 'none' }}>
                          <Box
                            sx={{
                              backgroundColor: getColor(
                                checkListStatus?.taskStatus
                              ),
                              borderRadius: '5px',
                              ...poppins400,
                              fontSize: '16px',
                              color: '#FFFFFF',
                              whiteSpace: 'nowrap',
                              height: '28px',
                              padding: '4px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            {checkListStatus?.ETA != null &&
                            (checkListStatus?.taskStatus == 'In Progress' ||
                              checkListStatus?.taskStatus == 'Requested')
                              ? 'ETA'
                              : checkListStatus?.taskStatus}{' '}
                            &nbsp;
                            {checkListStatus?.ETA != null &&
                              (checkListStatus?.taskStatus == 'In Progress' ||
                                checkListStatus?.taskStatus == 'Requested') && (
                                <>{formatETAStatus}</>
                              )}
                          </Box>
                        </TableCell>
                        <TableCell sx={{ borderBottom: 'none' }}>
                          <Typography
                            variant="subtitle1"
                            sx={{
                              fontFamily: 'poppins',
                              fontWeight: '400',
                              fontSize: '12px',
                            }}
                          >
                            {formatLastUpdate}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                  <Grid item xs={12}>
                    <Grid
                      container
                      justifyContent="space-between"
                      alignItems={'center'}
                      sx={{
                        padding: '0px 20px',
                        pb: '15px',
                        fontFamily: 'poppins',
                      }}
                    >
                      <Grid>
                        <Typography
                          onClick={() => {
                            handleCloseCheck();
                            history.push('/helpcentre');
                          }}
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px',
                            color: '#112347',
                            fontFamily: 'poppins',
                            fontSize: '14px',
                            fontWeight: 400,
                            margin: 0,
                            cursor: 'pointer',
                          }}
                        >
                          <InfoIcon />
                          Need Help ?
                        </Typography>
                      </Grid>
                      <Grid>
                        <Button
                          onClick={handleCloseCheck}
                          sx={{
                            padding: '10px 30px',
                            color: 'grey',
                            fontFamily: 'poppins',
                            border: '1px solid lightgrey',
                            textTransform: 'capitalize',
                          }}
                          variant="outlined"
                        >
                          Close
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Popover>
            </Grid>
          </Grid>

          <Grid
            sx={{
              marginTop: '80px',
              width: '100%',
              position: 'relative',
            }}
          >
            <Box
              ref={scrollTotabRef}
              sx={{
                width: '100%',
                display: matchessm && 'none',
              }}
            >
              <TabContext value={value}>
                <Box>
                  <Tabs
                    onChange={handleChanged}
                    aria-label="lab API tabs example"
                    variant="scrollable"
                    scrollButtons={matches900 && true}
                    allowScrollButtonsMobile={matches900 && true}
                    sx={{
                      '& .Mui-selected': {
                        color: '#6C2AD2',
                        borderBottom: '2px solid #6C2AD2',
                      },
                      '& .MuiTabs-indicator': {
                        backgroundColor: '#6C2AD2',
                      },
                    }}
                  >
                    {tabs.map((tab) => (
                      <Tab
                        disabled={
                          getBuyerIndividualValue?.PropertyDetails
                            ?.timerStatus === 'Pause' && tab.value !== '4'
                        }
                        sx={{
                          width: matches400
                            ? '100%'
                            : matches900
                            ? '50%'
                            : '25%',
                        }}
                        key={tab.value}
                        label={
                          <span
                            style={{
                              textTransform: 'none',
                              width: '158px',
                              height: '66px',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              padding: '12px 21px 12px 21px',
                              gap: '6px',
                            }}
                          >
                            {tab.label}
                          </span>
                        }
                        value={tab.value}
                        style={{
                          ...poppins500,
                          fontSize: '14px',
                          color: value === tab.value ? '#6C2AD2' : 'inherit',
                        }}
                      />
                    ))}
                  </Tabs>
                </Box>
                {tabs.map((tab) => (
                  <TabPanel
                    key={tab.value}
                    value={tab.value}
                    sx={{
                      p: '0px',
                      width: '100%',
                    }}
                  >
                    {renderTabContent(tab.value)}
                  </TabPanel>
                ))}
              </TabContext>
            </Box>
          </Grid>

          <Dialog
            open={matchessm && newTabData}
            onEntered={handleEntered}
            fullScreen={true}
            PaperProps={{
              sx: {
                '& .MuiDialog-paper': isDesktop && {
                  transform: `scale(${APP_SCALE})`,
                  transformOrigin: 'top right',
                },
                minWidth: '100%',
                minHeight: '100dvh', // Ensures full height on mobile without address bar
                paddingTop: 'env(safe-area-inset-top)', // Safe area for devices with notches
                position: 'sticky', // Fixes the dialog position
                top: 0,
              },
            }}
          >
            <Grid ref={dialogContentRef}>
              <TabContext value={value}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    background: '#6C2AD2',
                    padding: '20px',
                    width: '100%',
                    position: 'sticky',
                    top: 0,
                    zIndex: 20,
                    height: '70px',
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: 'poppins',
                      fontWeight: 300,
                      fontSize: '20px',
                      color: 'white',
                      marginLeft: 'auto',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '20px',
                      }}
                    >
                      {offerHistoryState ? (
                        <OfferHistory />
                      ) : tabData == '1' ? (
                        <SearchIconNew color={'white'} />
                      ) : tabData == '2' ? (
                        <ContractIconNew color={'white'} />
                      ) : tabData == '3' ? (
                        <DiligenceIconNew color={'white'} />
                      ) : (
                        <MakeOfferIconNew color={'white'} />
                      )}
                      <Typography
                        style={{
                          fontFamily: 'Poppins',
                          fontSize: '20px',
                          fontWeight: 300,
                          textTransform: 'capitalize',
                          textAlign: 'center',
                          margin: '0 auto',
                          color: 'white',
                        }}
                      >
                        {offerHistoryState
                          ? 'Offer History'
                          : tabData == '1'
                          ? 'Organise Inspection'
                          : tabData == '2'
                          ? 'View Contract'
                          : tabData == '3'
                          ? 'Due Diligence'
                          : 'Make Offer'}
                      </Typography>
                    </Box>
                  </Typography>
                  <CloseIcon
                    onClick={() => {
                      setNewTabData(false);
                      setTabDAta('0');
                      SetHideOthers(false);
                      setShowPropertyTimer(false);
                      setOfferHistoryState(false);
                    }}
                    sx={{
                      fontSize: '50px',
                      color: 'white',
                      marginLeft: 'auto',
                    }}
                  />
                </Box>
                {!currentPage.includes('/share') &&
                  getBuyerIndividualValue?.PropertyDetails?.timerStatus !=
                    'End' && (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-around',
                        alignItems: 'center',
                        background:
                          getBuyerIndividualValue?.PropertyDetails?.stage ===
                          'ST2'
                            ? '#FF5050'
                            : '#7E7C7C',
                        position: 'sticky',
                        top: '68px',
                        zIndex: 20,
                        height: '39px',
                        padding: '0 16px 0 10px',
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: 'poppins',
                          fontWeight: 400,
                          fontSize: '12px',
                          color: 'white',
                          minWidth: '106px',
                          marginTop: '4px',
                        }}
                      >
                        Offers close in :
                      </Typography>
                      <Box sx={{ minWidth: '246px', marginLeft: '-10px' }}>
                        <PropertyTimer
                          propertyData={
                            getBuyerIndividualValue?.PropertyDetails
                          }
                          upperCountDown={'upperCountDown'}
                          isMakeOfferSm={true}
                        />
                      </Box>
                    </Box>
                  )}

                <Box
                  ref={scrollContainerRef}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: '20px',
                    marginBottom: '20px',
                  }}
                >
                  <IconButton sx={{ height: '20px' }}>
                    <Locationsmallblack />
                  </IconButton>
                  <Typography
                    sx={{
                      fontSize: '20px',
                      fontWeight: 400,
                      fontFamily: 'poppins',
                      maxWidth: '80%',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {
                      getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                        ?.streetName
                    }
                  </Typography>
                </Box>
                <Box>
                  {tabs.map((tab) => (
                    <TabPanel
                      key={tab.value}
                      value={tab.value}
                      sx={{
                        p: '0px',
                        width: '100%%',
                      }}
                    >
                      {renderTabContent(tab.value)}
                    </TabPanel>
                  ))}
                </Box>
              </TabContext>
            </Grid>
            {hideOthers && !showPropertyTimer && tabData == '4' && (
              <Button
                onClick={() => {
                  setShowPropertyTimer(false);
                  setNewTabData(true);
                  SetHideOthers(false);
                  setOfferHistoryState(false);
                  setTabDAta('4');
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '85%',
                  margin: '0 auto 100px auto',
                  background: '#6C2AD2',
                  padding: '10px',
                }}
                variant="contained"
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '20px',
                  }}
                >
                  <MakeOfferIconNew color={'white'} />
                  <Typography
                    sx={{
                      fontSize: '16px',
                      fontFamily: 'poppins',
                      fontWeight: 400,
                      textTransform: 'capitalize',
                    }}
                  >
                    Make Offer
                  </Typography>
                </Box>
              </Button>
            )}
            {!hideOthers && tabData != '4' && !offerHistoryState && (
              <Box sx={{ padding: '20px' }}>
                <BuyingActions
                  setTabData={setTabDAta}
                  setNewTabData={setNewTabData}
                  newTabData={newTabData}
                  tabData={tabData}
                  buttonStyles={buttonStyles}
                  typographyStyles={typographyStyles}
                  cancelButtonStyles={cancelButtonStyles}
                  cancelTextStyles={cancelTextStyles}
                  SetHideOthers={SetHideOthers}
                  setShowPropertyTimer={setShowPropertyTimer}
                  cancelButton={true}
                  handleScrollToTop={handleScrollToTop}
                />
              </Box>
            )}
            {matchessm && (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  position: 'fixed',
                  right: 0,
                  top: matchessm ? '300px' : matchesmd ? '350px' : '450px',
                  zIndex: 4,
                }}
              >
                <Box
                  onClick={() => {
                    handleScrollToTop();
                    SetHideOthers(true);
                    setTabDAta('4');
                    setNewTabData(true);
                    setShowPropertyTimer(false);
                    setOfferHistoryState(true);
                  }}
                >
                  <HighestOffersSVG
                    fill={tabData == '4' && hideOthers ? true : false}
                  />
                </Box>
                <Box
                  onClick={() => {
                    handleScrollToTop();
                    SetHideOthers(false);
                    setTabDAta('4');
                    setNewTabData(true);
                    setShowPropertyTimer(false);
                    setOfferHistoryState(false);
                  }}
                >
                  <MakeOffersSVG
                    fill={tabData == '4' && !hideOthers ? true : false}
                  />
                </Box>
              </Box>
            )}
          </Dialog>

          <Dialog
            open={showPropertyTimer}
            onClose={showPropertyTimer && onCloseFunction}
            BackdropProps={{
              sx: {
                backdropFilter: 'blur(8px)',
                backgroundColor: 'transparent',
              },
            }}
            PaperProps={{
              sx: {
                minWidth: '100%',
                minHeight: '300px',
                backgroundColor: 'transparent',
              },
            }}
          >
            <Grid
              item
              sx={{
                backgroundColor: '#FFFFFF',
                width: '100%',
                p: '15px 15px 0 15px',
                justifyContent: 'space-between',
              }}
            >
              <Grid
                sx={{
                  height: '17%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Box>
                  <Clock />
                  <Typography
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontStyle: 'normal !important',
                      fontWeight: '500 !important',
                      fontSize: '16px',
                      color: '#212529',
                      marginTop: '20px',
                      marginLeft: '11px',
                    }}
                  >
                    Offers close in:
                  </Typography>
                </Box>
                <Grid
                  sx={{ display: 'flex', flexDirection: 'row', gap: '2px' }}
                >
                  {getBuyerIndividualValue?.PropertyDetails?.timerStatus ==
                    'Pause' && (
                    <Box sx={{ paddingTop: '6px' }}>
                      <PauseIcon width={21} height={21} />
                    </Box>
                  )}
                  <Typography
                    sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textAlign: 'center',
                      height: '20px',
                      margin: '10px',
                      padding: '3px 12px',
                      fontFamily: 'Poppins !important',
                      fontStyle: 'normal !important',
                      fontWeight: '600 !important',
                      fontSize: '12px',
                      color: '#FFFFFF',
                      borderRadius: '2px',
                      bgcolor:
                        getBuyerIndividualValue?.PropertyDetails?.stage ===
                        'ST2'
                          ? '#F93939'
                          : getBuyerIndividualValue?.PropertyDetails?.stage ===
                            'ST1'
                          ? '#10D35E'
                          : getBuyerIndividualValue?.PropertyDetails?.property
                              ?.status == 'Sold'
                          ? '#F93939'
                          : '#529AEE',
                    }}
                  >
                    {getBuyerIndividualValue?.PropertyDetails?.stage == 'ST1'
                      ? 'STAGE 1'
                      : getBuyerIndividualValue?.PropertyDetails?.stage == 'ST2'
                      ? getBuyerIndividualValue?.PropertyDetails?.isReset == '1'
                        ? 'STAGE 2 - FINAL OFFERS'
                        : 'STAGE 2'
                      : getBuyerIndividualValue?.PropertyDetails?.property
                          ?.status == 'Sold'
                      ? 'Sold'
                      : 'Unpublished'}
                  </Typography>
                </Grid>
              </Grid>

              <Card
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  height: '151px',
                  width: '100%',
                  background: '#FFFFFF',
                  boxShadow: 'none',
                  letterSpacing: '1%',
                }}
              >
                <Box
                  sx={{ marginTop: '10px', minWidth: '100%', height: '50px' }}
                >
                  <PropertyTimer
                    propertyData={getBuyerIndividualValue?.PropertyDetails}
                    upperCountDown={'upperCountDown'}
                  />
                </Box>
                <Box sx={{ position: 'relative', top: '-15px' }}>
                  <PropertyTimer
                    newUI={true}
                    propertyData={getBuyerIndividualValue?.PropertyDetails}
                    timerStatus={
                      getBuyerIndividualValue?.PropertyDetails?.timerStatus
                    }
                  />
                </Box>
              </Card>
              <Button
                onClick={() => {
                  setShowPropertyTimer(false);
                  setNewTabData(true);
                  setTabDAta('4');
                  SetHideOthers(false);
                  setOfferHistoryState(false);
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '85%',
                  margin: '5px auto 20px auto',
                  background: '#6C2AD2',
                  padding: '10px',
                }}
                variant="contained"
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '20px',
                  }}
                >
                  <MakeOfferIconNew color={'white'} />
                  <Typography
                    sx={{
                      fontSize: '16px',
                      fontFamily: 'poppins',
                      fontWeight: 400,
                      textTransform: 'capitalize',
                    }}
                  >
                    Make Offer
                  </Typography>
                </Box>
              </Button>
              {matchessm && (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'fixed',
                    right: 0,
                    top: matchessm ? '300px' : matchesmd ? '350px' : '450px',
                    zIndex: 4,
                  }}
                >
                  <Box
                    onClick={() => {
                      SetHideOthers(true);
                      setTabDAta('4');
                      setNewTabData(true);
                      setShowPropertyTimer(false);
                      setOfferHistoryState(true);
                    }}
                  >
                    <HighestOffersSVG
                      fill={tabData == '4' && hideOthers ? true : false}
                    />
                  </Box>
                  <Box
                    onClick={() => {
                      SetHideOthers(false);
                      setTabDAta('4');
                      setNewTabData(true);
                      setShowPropertyTimer(false);
                      setOfferHistoryState(false);
                    }}
                  >
                    <MakeOffersSVG
                      fill={tabData == '4' && !hideOthers ? true : false}
                    />
                  </Box>
                </Box>
              )}
            </Grid>
          </Dialog>

          {matchessm && (
            <BuyingActions
              setTabData={setTabDAta}
              setNewTabData={setNewTabData}
              newTabData={newTabData}
              tabData={tabData}
              buttonStyles={buttonStyles}
              typographyStyles={typographyStyles}
              cancelButtonStyles={cancelButtonStyles}
              cancelTextStyles={cancelTextStyles}
              SetHideOthers={SetHideOthers}
              setShowPropertyTimer={setShowPropertyTimer}
              cancelButton={false}
              handleScrollToTop={handleScrollToTop}
            />
          )}

          <div style={{ width: '100%' }}>
            <Grid
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'start',
                marginTop: '20px',
              }}
            >
              <Box
                style={{
                  cursor: 'pointer',
                  borderColor: '#DFDFDF',
                  border: '2px solid #DFDFDF',
                  height: '48px',
                  width: '208px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                onClick={() => {
                  setHideActivateTrade(true);
                  setShowActivateTrade(false);
                }}
              >
                <img
                  src={BackArrow}
                  style={{
                    marginRight: '10px',
                  }}
                />
                <Typography sx={{ ...poppins500, fontSize: '16px' }}>
                  Back To Property
                </Typography>
              </Box>
            </Grid>
          </div>
          <div id="myGrid" style={{ height: '150px' }}></div>
        </Grid>
        {getBuyerIndividualValue?.PropertyDetails?.timerStatus !== 'End' &&
          getBuyerIndividualValue?.PropertyDetails?.stage == 'ST2' && (
            <CardActionArea
              onClick={
                getBuyerIndividualValue?.PropertyDetails?.highestOffer == null
                  ? null
                  : handleClickOpenFocus
              }
              disableRipple={
                getBuyerIndividualValue?.PropertyDetails?.highestOffer == null
              }
              sx={{
                cursor:
                  getBuyerIndividualValue?.PropertyDetails?.highestOffer == null
                    ? 'not-allowed'
                    : '',
                position: 'fixed', // Fix to the viewport
                right: '0px', // Distance from the right edge of the screen
                top: '50%', // Vertically center relative to the viewport
                transform: 'translateY(-50%)', // Perfect vertical centering
                display: matchesmd ? 'none' : 'flex',
                flexDirection: 'column',
                background: '#f1eafb',
                borderRadius: '10px 0 0 10px',
                height: '139px',
                width: '146px',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                gap: 0.6,
                boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px',
                zIndex: 29,
              }}
            >
              <Box>
                <FocusModeIcon />
              </Box>
              <Typography
                sx={{
                  fontFamily: 'Poppins, sans-serif',
                  fontWeight: 500,
                  fontSize: '18px',
                  color: '#6C2AD2',
                }}
              >
                Focus Mode
              </Typography>
            </CardActionArea>
          )}
        {openFocusDialog && (
          <FocusModePopup
            open={openFocusDialog}
            handleCloseFocus={handleCloseFocus}
            dateupdated={dateupdated}
            setTabDAta={setTabDAta}
            setNewTabData={setNewTabData}
            setShowPropertyTimer={setShowPropertyTimer}
            offerHistoryState={offerHistoryState}
            tabData={tabData}
            hideOthers={hideOthers}
            SetHideOthers={SetHideOthers}
            hideActivateTrade={hideActivateTrade}
            setHideActivateTrade={setHideActivateTrade}
            makeOfferListArray={makeOfferListArray}
            lastHighestOffers={lastHighestOffers}
            setLastHighestOffers={setLastHighestOffers}
            withdrawLeftCount={withdrawLeftCount}
            array={array}
            setShowActivateTrade={setShowActivateTrade}
            makeOfferRef={makeOfferRef}
            stage={getBuyerIndividualValue?.PropertyDetails?.stage}
            groupIt={groupIt}
            groupCall={groupCall}
            getlistMakeOffer={getlistMakeOffer}
            getBuyerIndividualValue={getBuyerIndividualValue}
            confirmAcceptLog={confirmAcceptLog}
            setOpenlogin={setOpenlogin}
            openlogin={openlogin}
            sharedpage={sharedpage}
            doc66wstatus={doc66wstatus}
            st1condition={st1condition}
            st2condition={st2condition}
            isFirstOffer={isFirstOffer}
            setDontallowtooffer={setDontallowtooffer}
            isFocusMode={true}
            offersOnly={offersOnly}
            setOffersOnly={setOffersOnly}
            checkListArray={checkListArray}
            isStageTwoRequested={isStageTwoRequested}
            setIsStageTwoRequested={setIsStageTwoRequested}
            focusModeActionTabSwitching={focusModeActionTabSwitching}
            directcomm={directcomm}
            isAuction={isAuction}
            auctionDetails={auctionDetails}
            lastLatestOffer={lastLatestOffer}
            setOpensolicitorpopup={setOpensolicitorpopup}
            setTypeofsolicitorpopup={setTypeofsolicitorpopup}
          />
        )}
      </Grid>
      {openConfirmingPopup && (
        <ConfirmingParticipationStageTwo
          openConfirmingPopup={openConfirmingPopup}
          setOpenConfirmingPopup={setOpenConfirmingPopup}
          getBuyerIndividualValue={getBuyerIndividualValue}
          groupIt={groupIt}
          groupCall={groupCall}
        />
      )}

      <Dialog
        open={openCard}
        onClose={() => setOpenCard(!openCard)}
        onLoad={() => {
          timerfun();
        }}
        PaperProps={{
          sx: {
            height: '790px',
            borderRadius: '8px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: '30px',
            overflow: 'hidden',
          },
        }}
        zIndex={200000}
      >
        <Grid container>
          <Grid item>
            <Typography
              sx={{
                fontFamily: 'poppins!important',
                fontSize: '14px!important',
                fontWeight: 400,
                color: '#666666',
              }}
            >
              {
                getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                  ?.streetName
              }
            </Typography>
            {isLoading ? (
              <Grid
                item
                display={'flex'}
                alignItems={'center'}
                padding={'10px 0px'}
              >
                <Warning />
                <Typography
                  sx={{
                    ...poppins500,
                    fontSize: '24px',
                    paddingLeft: '12px',
                    color: '#000000',
                  }}
                >
                  Accepting Offer
                </Typography>
              </Grid>
            ) : (
              <Grid
                item
                display={'flex'}
                alignItems={'center'}
                padding={'10px 0px'}
              >
                <Warning />
                <Typography
                  sx={{
                    ...poppins500,
                    fontSize: '24px',
                    paddingLeft: '12px',
                    color: '#000000',
                  }}
                >
                  <Grid
                    item
                    display={'flex'}
                    alignItems={'center'}
                    padding={'10px 0px'}
                  >
                    <Typography
                      sx={{
                        ...poppins500,
                        fontSize: '24px',
                        paddingLeft: '8px',
                        color: '#000000',
                      }}
                    >
                      Offer Accepted Successfully
                    </Typography>
                  </Grid>
                </Typography>
              </Grid>
            )}
            {isLoading ? (
              <Grid sx={{ marginTop: '15px' }}>
                <Typography
                  sx={{
                    paddingTop: '8px',
                    fontFamily: 'poppins!important',
                    fontSize: '16px!important',
                    fontWeight: 400,
                    color: '#666666',
                    justifyContent: 'center',
                    alignItems: 'center',

                    marginTop: '0px',
                    justifyItems: 'self-end',
                  }}
                >
                  You are accepting the counter offer
                </Typography>
              </Grid>
            ) : (
              <Grid sx={{ marginTop: '15px' }}>
                <Typography
                  sx={{
                    paddingTop: '8px',
                    fontFamily: 'poppins!important',
                    fontSize: '16px!important',
                    fontWeight: 400,
                    color: '#666666',
                    justifyContent: 'center',
                    alignItems: 'center',

                    marginTop: '0px',
                    justifyItems: 'self-end',
                  }}
                >
                  You are accepted the counter offer
                </Typography>
              </Grid>
            )}
          </Grid>

          <Grid container>
            <Grid>
              <Typography
                sx={{
                  border: '1px solid #D9D9D9',
                  width: '761px',
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  textAlign: 'center',
                  marginTop: '22px',
                  marginLeft: '-28px',
                }}
              ></Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={{
              paddingTop: '80px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {isLoading ? <Spinner /> : <Sign />}
          </Grid>
          {isLoading ? (
            <Grid container gap={2} marginTop={'145px'} justifyContent={'end'}>
              <Grid item sx={{ marginTop: '8px' }}>
                <DecreasingCounter
                  Offer={
                    getBuyerIndividualValue?.PropertyDetails?.offerStatus
                      ?.price || ''
                  }
                  offerId={
                    getBuyerIndividualValue?.PropertyDetails?.buyerOfferId
                  }
                  groupIt={groupIt}
                  openBox={openBox}
                  setOpenBox={setOpenBox}
                  setShowTick={setShowTick}
                  setIsLoading={setIsLoading}
                  offerUniqueId={
                    getBuyerIndividualValue?.PropertyDetails
                      ?.highestOfferUniqueId
                  }
                />
              </Grid>
              <Grid item>
                <Button
                  variant="outlined"
                  style={{
                    padding: '10px 39px',
                    width: '100%',
                    height: '41px',
                    fontSize: '14px',
                    color: '#666666',
                    fontWeight: '400',
                    fontFamily: 'Poppins',
                    border: '1px solid rgba(17, 35, 71, 0.1)',
                    borderRadius: '5px',
                  }}
                  onClick={() => {
                    setIsLoading(true);
                    setShowTick(false);
                    setOpenCard(false);
                    setOpenBox(false);
                  }}
                >
                  Cancel
                </Button>
              </Grid>
            </Grid>
          ) : (
            <Grid container marginTop={'105px'} justifyContent={'end'}>
              <Grid item>
                <Button
                  variant="outlined"
                  style={{
                    padding: '10px 39px',
                    width: '100%',
                    height: '41px',
                    fontSize: '14px',
                    backgroundColor: '#4CA4D6',
                    color: '#FFFFFF',
                    fontWeight: '400',
                    fontFamily: 'Poppins',
                    borderRadius: '5px',
                  }}
                  onClick={() => {
                    setOpenCard(false);
                    setOpenBox(false);
                    setIsLoading(true);
                    setShowTick(false);
                  }}
                >
                  Close
                </Button>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Dialog>
      <Dialog
        open={openBox}
        onClose={() => setOpenBox(!openBox)}
        PaperProps={{
          sx: {
            borderRadius: '8px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: matchessm ? '30px 20px' : '30px',
            zIndex: '1000000',
          },
        }}
      >
        <Grid container>
          <Grid item>
            <Typography
              sx={{
                fontFamily: 'poppins!important',
                fontSize: matchessm ? '10px' : '14px!important',
                fontWeight: 400,
                color: '#666666',
              }}
            >
              {
                getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                  ?.streetName
              }
            </Typography>
            <Grid
              item
              display={'flex'}
              alignItems={'center'}
              padding={'10px 0px'}
            >
              <Warning />
              <Typography
                sx={{
                  ...poppins500,
                  fontSize: matchessm ? '15px' : '24px',
                  paddingLeft: '12px',
                  color: '#000000',
                }}
              >
                Confirming Acceptance
              </Typography>
            </Grid>
            <Grid sx={{ marginTop: '15px' }}>
              <Typography
                sx={{
                  paddingTop: '8px',
                  fontFamily: 'poppins!important',
                  fontSize: matchessm ? '12px' : '16px!important',
                  fontWeight: 400,
                  color: '#666666',
                  justifyContent: 'center',
                  alignItems: 'center',

                  marginTop: '0px',
                  justifyItems: 'self-end',
                }}
              >
                You are accepting the vendor's counter offer. Please note, by
                accepting this offer, you are still in competition with other
                interested parties.
              </Typography>
            </Grid>
          </Grid>
          <Grid container>
            <Grid>
              <Typography
                sx={{
                  border: '1px solid #D9D9D9',
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  textAlign: 'center',
                  marginTop: matchessm ? '10px' : '22px',
                }}
              ></Typography>
            </Grid>
          </Grid>
          <Grid sx={{ justifyContent: 'flex-start' }}>
            <Typography
              sx={{
                fontFamily: 'poppins!important',
                fontSize: matchessm ? '16px' : '24px!important',
                fontWeight: 400,
                color: '#000000',
              }}
            >
              Offer Summary
            </Typography>
          </Grid>
          <Grid
            container
            paddingTop={'25px'}
            spacing={12}
            justifyItems={'self-end'}
          >
            <Grid item>
              <Typography
                sx={{
                  fontFamily: 'poppins!important',
                  fontSize: matchessm ? '12px' : '16px!important',
                  fontWeight: 400,
                  color: '#666666',
                }}
              >
                {' '}
                Price:
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                sx={{
                  fontFamily: 'poppins!important',
                  fontSize: matchessm ? '12px' : '16px!important',
                  fontWeight: 400,
                  color: '#000000',
                }}
              >
                {getBuyerIndividualValue?.PropertyDetails?.offerStatus?.price ||
                  '-'}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={5}
            justifyItems={'self-end'}
            paddingTop={'15px'}
          >
            <Grid item>
              <Typography
                sx={{
                  fontFamily: 'poppins!important',
                  fontSize: matchessm ? '12px' : '16px!important',
                  fontWeight: 400,
                  color: '#666666',
                }}
              >
                {' '}
                Offer Status:
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                sx={{
                  fontFamily: 'poppins!important',
                  fontSize: matchessm ? '12px' : '16px!important',
                  fontWeight: 400,
                  color: '#000000',
                }}
              >
                {' '}
                Conditional{' '}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={6}
            justifyItems={'self-end'}
            paddingTop={'15px'}
          >
            <Grid item>
              <Typography
                sx={{
                  fontFamily: 'poppins!important',
                  fontSize: matchessm ? '12px' : '16px!important',
                  fontWeight: 400,
                  color: '#666666',
                }}
              >
                {' '}
                Settlement:
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                sx={{
                  fontFamily: 'poppins!important',
                  fontSize: matchessm ? '12px' : '16px!important',
                  fontWeight: 400,
                  color: '#000000',
                }}
              >
                42 days
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={5}
            justifyItems={'self-end'}
            paddingTop={'15px'}
          >
            <Grid item>
              <Typography
                sx={{
                  fontFamily: 'poppins!important',
                  fontSize: matchessm ? '12px' : '16px!important',
                  fontWeight: 400,
                  color: '#666666',
                }}
              >
                Conditions:
              </Typography>
            </Grid>
          </Grid>
          {getBuyerIndividualValue?.PropertyDetails?.getBuyerCondition?.length >
            0 &&
            getBuyerIndividualValue?.PropertyDetails?.getBuyerCondition?.map(
              (item) => {
                return (
                  <Grid sx={{ display: 'flex', spacing: 2 }}>
                    <Stack
                      sx={{
                        textAlign: 'center',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        display: 'flex',
                        paddingLeft: '31px',
                        paddingTop: '45px',
                      }}
                    >
                      <img
                        src={item?.conditionSubjectFile}
                        alt="note"
                        style={{
                          width: '33px',
                          height: '45px',

                          marginLeft: '74px',
                        }}
                      />

                      <Stack marginTop={'17px'}>
                        <Typography
                          sx={{
                            fontFamily: 'Poppins !important',
                            fontStyle: 'normal !important',
                            fontWeight: '300 !important',
                            fontSize: matchessm ? '12px' : '14px',
                            color: '#6C2AD2',
                          }}
                        >
                          {item?.conditionSubjectValue}
                        </Typography>
                      </Stack>
                    </Stack>
                  </Grid>
                );
              }
            )}

          <Grid
            container
            gap={matchessm ? 1 : 2}
            sx={{ display: 'flex' }}
            marginTop={matchessm ? '10px' : '45px'}
            justifyContent={'end'}
          >
            <Grid item>
              <Button
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                }}
                onClick={() => {
                  setIsLoading(true);
                  setOpenBox(!openBox);
                }}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                onClick={() => {
                  setOpenBox(false);
                  setOpenCard(!openCard);
                  submitOffer(
                    getBuyerIndividualValue?.PropertyDetails?.offerStatus
                      ?.price || ''
                  );
                }}
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                }}
              >
                &nbsp;Accept&nbsp;
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>

      <Dialog
        open={open}
        onClose={() => {
          handleCancelEdit();
          setOpen(false);
        }}
        isDisabled={isDisabled}
        PaperProps={{
          sx: {
            position: 'absolute',
            borderRadius: '8px',
            width: matchessm ? '100%' : '600px',
            maxWidth: matchessm ? '100%' : '600px',
            background: '#FFFFFF',
            border: '0.5px solid #D9D9D9',
            padding: matchessm ? '20px' : '30px',
          },
        }}
      >
        <Grid
          container
          sx={{ gap: '20px', display: 'flex', flexDirection: 'column' }}
        >
          <Grid item>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '12px' : '16px',
                color: '#666666',
              }}
            >
              {getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                ?.streetName || '-'}
            </Typography>
          </Grid>
          <Grid
            item
            sx={{
              display: 'flex',
              gap: '5px',
            }}
          >
            <Pendingwarning />
            {deleteInsp == 1 ? (
              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  fontStyle: 'normal',
                  fontWeight: '500',
                  fontSize: matchessm ? '18px' : '24px',
                  color: '#000000',
                }}
              >
                Delete Inspection
              </Typography>
            ) : editInsp ? (
              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  fontStyle: 'normal',
                  fontWeight: '500',
                  fontSize: matchessm ? '18px' : '24px',
                  color: '#000000',
                }}
              >
                Edit Inspection
              </Typography>
            ) : (
              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  fontStyle: 'normal',
                  fontWeight: '500',
                  fontSize: matchessm ? '18px' : '24px',
                  color: '#000000',
                }}
              >
                Confirm Attendance
              </Typography>
            )}
          </Grid>
          <Grid item>
            <Typography
              sx={{
                fontFamily: 'Poppins',
                fontWeight: '400',
                fontSize: matchessm ? '14px' : '16px',
                color: '#666666',
              }}
            >
              You are about to{' '}
              {deleteInsp == 1 ? 'delete' : editInsp ? 'edit' : 'schedule'} a
              property inspection for{' '}
              <span
                style={{
                  fontFamily: 'Poppins',
                  fontWeight: 600,
                  color: '#666666',
                  fontSize: matchessm ? '14px' : '16px',
                }}
              >
                {getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                  ?.streetName || '-'}{' '}
              </span>
              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  fontWeight: '400',
                  fontSize: matchessm ? '14px' : '16px',
                  color: '#666666',
                }}
              >
                at{' '}
                <span>
                  <b
                    style={{
                      fontFamily: 'Poppins',
                      fontWeight: 600,
                      color: '#666666',
                    }}
                  >
                    {scheduleItemData?.dateTime
                      ? deleteInsp == 1
                        ? moment(
                            scheduleItemData.dateTime,
                            'YYYY-MM-DD HH:mm:ss'
                          ).format('hh:mm A DD-MM-YYYY')
                        : editInsp == 1
                        ? moment(
                            scheduleItemData.dateTime,
                            'HH:mm:ss DD-MM-YYYY'
                          ).format('hh:mm A DD-MM-YYYY')
                        : confirmPopupSource === 'attendInspection'
                        ? moment(
                            scheduleItemData.dateTime,
                            'YYYY-MM-DD HH:mm:ss'
                          ).format('hh:mm A DD-MM-YYYY')
                        : confirmPopupSource === 'privateInspection'
                        ? moment(
                            scheduleItemData.dateTime,
                            'HH:mm:ss DD-MM-YYYY'
                          ).format('hh:mm A DD-MM-YYYY')
                        : moment
                            .tz(
                              scheduleItemData.dateTime,
                              'HH:mm:ss DD-MM-YYYY',
                              'Australia/Sydney'
                            )
                            .format('HH:mm DD-MM-YYYY')
                      : ''}
                  </b>
                </span>
              </Typography>
            </Typography>
          </Grid>
          <Grid
            item
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Box sx={{ display: 'flex', gap: '20px' }}>
              <Button
                disabled={listScheduleLoader}
                onClick={() => {
                  handleCancelEdit();
                  setOpen(false);
                }}
                sx={{
                  borderRadius: '5px',
                  padding: '5px 20px',
                  ...poppins400,
                  fontSize: '14px',
                  color: '#666666',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  textTransform: 'capitalize',
                }}
              >
                Cancel
              </Button>
              {!isDisabled && (
                <Button
                  onClick={() => {
                    if (sharedpage) {
                      setOpenlogin(!openlogin);
                      setOpen(false);
                    } else {
                      localStorage.setItem('inspectionDate', scheduleDate);
                      localStorage.setItem('inspectionTime', scheduleTime);
                      localStorage.setItem(
                        'inspectionItem',
                        JSON.stringify(scheduleItemData)
                      );
                      scheduledInspectionRequest('');
                    }
                  }}
                  disabled={listScheduleLoader}
                  sx={{
                    borderRadius: '5px',
                    padding: '5px 20px',
                    ...poppins400,
                    fontSize: '14px',
                    color: '#FFFFFF',
                    backgroundColor: '#4CA4D6',
                    textTransform: 'capitalize',
                    '&:hover': {
                      bgcolor: '#4CA4D6',
                      color: '#FFFFFF',
                      boxShadow: 'none',
                      cursor: 'pointer',
                    },
                  }}
                >
                  {deleteInsp ? 'Delete' : 'Confirm'}
                </Button>
              )}
              {listScheduleLoader && (
                <img
                  alt="Logo"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '40px', width: '40px' }}
                />
              )}
            </Box>
          </Grid>
        </Grid>
      </Dialog>

      {/* Sign Contract confirm dialog  */}
      {offerPrice == '' ? (
        <Dialog
          open={openBoxSign}
          PaperProps={{
            sx: {
              borderRadius: '5px',
              width: '100%',
            },
          }}
        >
          <Grid
            container
            sx={{
              display: 'flex',
              flexDirection: 'column',
              padding: matches900 ? '20px' : '30px',
              gap: '20px',
            }}
          >
            <Grid item>
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontWeight: 400,
                  fontSize: matchessm ? '10px' : '14px',
                  color: '#666666',
                }}
              >
                {
                  getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                    ?.streetName
                }
              </Typography>
            </Grid>
            <Grid
              item
              sx={{ display: 'flex', flexDirection: 'row', gap: '10px' }}
            >
              <OrangePendingwarning matches700={matches700} />
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontWeight: 400,
                  fontSize: matchessm ? '16px' : '24px',
                }}
              >
                Request E-sign
              </Typography>
            </Grid>
            <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontWeight: 400,
                  fontSize: matchessm ? '12px' : '16px',
                  color: '#666666',
                }}
              >
                You have not submitted any offers yet. Please make an offer to
                request e-sign.
              </Typography>
            </Grid>
          </Grid>

          <Grid
            item
            container
            sx={{
              padding: matches900 ? '20px' : '30px',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              gap: '30px',
            }}
          >
            <Grid item>
              <Button
                onClick={() => setOpenBoxSign(false)}
                disabled={loading}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '15px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                onClick={() => {
                  if (matchessm) {
                    handleMakeOfferClick();
                    document.documentElement.scrollTo({
                      top: 10,
                      behavior: 'smooth',
                    });
                  } else {
                    setOpenBoxSign(false);
                    setTabDAta('4');
                    window.scroll({
                      top: 2000,
                      behavior: 'smooth',
                    });
                  }
                }}
                style={{
                  padding: matchessm ? '6px 25px' : '10px 35px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '15px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
              >
                Make Offer
              </Button>
            </Grid>
          </Grid>
        </Dialog>
      ) : (
        <Dialog
          open={openBoxSign}
          onClose={() => setOpenBoxSign(!openBoxSign)}
          PaperProps={{
            sx: {
              borderRadius: '8px',
              boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
              padding: matchessm ? '30px 20px' : '30px',
              zIndex: '1000000',
            },
          }}
        >
          <Grid container>
            <Grid item>
              <Grid item xs={12}>
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: matchessm ? '10px' : '14px',
                    color: '#666666',
                  }}
                >
                  {'   '}
                  {
                    getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                      ?.streetName
                  }
                  &nbsp;
                </Typography>
              </Grid>
              <Grid
                item
                display={'flex'}
                alignItems={'center'}
                padding={'12px 0px 15px 0'}
              >
                <Pendingwarning />
                <Typography
                  sx={{
                    ...poppins500,
                    fontSize: matchessm ? '16px' : '24px',
                    paddingLeft: '12px',
                    color: '#000000',
                  }}
                >
                  Request E-sign
                </Typography>
              </Grid>
              <Grid sx={{ marginTop: '8px' }}>
                <Typography
                  sx={{
                    fontFamily: 'poppins!important',
                    fontSize: matchessm ? '12px' : '16px!important',
                    fontWeight: 400,
                    color: '#666666',
                    justifyContent: 'center',
                    alignItems: 'center',

                    marginTop: '0px',
                    justifyItems: 'self-end',
                  }}
                >
                  Please confirm if you would like to submit a request to have
                  your contract of sale prepared for signing.
                </Typography>
              </Grid>
            </Grid>

            <Grid
              container
              gap={matchessm ? '7px' : 2}
              marginTop={matchessm ? '10px' : '45px'}
              justifyContent={'end'}
            >
              <Grid item>
                <Button
                  disabled={isLoadingSign}
                  variant="outlined"
                  style={{
                    padding: matchessm ? '6px 17px' : '10px 39px',
                    width: '100%',
                    height: matchessm ? '35px' : '41px',
                    fontSize: matchessm ? '12px' : '14px',
                    color: '#666666',
                    fontWeight: '400',
                    fontFamily: 'Poppins',
                    border: '1px solid rgba(17, 35, 71, 0.1)',
                    borderRadius: '5px',
                    textTransform: 'capitalize',
                  }}
                  onClick={() => {
                    setOpenBoxSign(false);
                    if (location.state?.openBoxSignDashboard) {
                      history.push({
                        pathname: history.location.pathname,
                        state: {
                          propertyIds: true,
                          openBoxSignDashboard: false,
                        },
                      });
                    }
                  }}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
                <Button
                  disabled={isLoadingSign}
                  onClick={() => {
                    handleSignContract(
                      getBuyerIndividualValue?.PropertyDetails?.agentDetails
                        ?.agentName,
                      getBuyerIndividualValue?.PropertyDetails?.agentDetails
                        ?.agentSurName
                    );
                  }}
                  variant="outlined"
                  style={{
                    padding: matchessm ? '6px 17px' : '10px 20px',
                    width: '100%',
                    height: matchessm ? '35px' : '41px',
                    fontSize: matchessm ? '12px' : '14px',
                    color: '#FFFFFF',
                    fontWeight: '400',
                    fontFamily: 'Poppins',
                    background: '#4CA4D6',
                    borderRadius: '5px',
                    textTransform: 'capitalize',
                  }}
                >
                  &nbsp;Confirm&nbsp;
                </Button>
                {isLoadingSign && (
                  <img
                    alt="Logo"
                    src={Loading}
                    className="loaderImage"
                    style={{ height: '40px', width: '40px' }}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
        </Dialog>
      )}

      <Dialog
        PaperProps={{
          sx: {
            borderRadius: '8px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: '25px',
            zIndex: '1000000',
            minWidth: matchessm ? '95%' : '650px',
          },
        }}
        open={uploaddocuments}
      >
        <Grid container>
          <Grid item xs={12} display={'flex'} alignItems={'center'}>
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '10px' : '14px',
                color: '#666',
                fontWeight: 400,
              }}
            >
              {
                getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                  ?.streetName
              }
            </Typography>
          </Grid>
          <Grid container>
            <Grid
              item
              xs={12}
              display={'flex'}
              alignItems={'center'}
              padding={'10px 0px'}
            >
              <Pendingwarning />
              <Typography
                sx={{
                  ...poppins500,
                  fontSize: matchessm ? '16px' : '24px',
                  marginLeft: '10px',
                  color: '#000000',
                }}
              >
                Confirm Contract Reviewed
              </Typography>
            </Grid>
            <Grid sx={{ marginTop: '20px' }}>
              <Typography
                sx={{
                  fontFamily: 'poppins!important',
                  fontSize: matchessm ? '12px' : '16px!important',
                  fontWeight: 400,
                  color: '#666666',
                  justifyContent: 'center',
                  alignItems: 'center',

                  marginTop: '0px',
                  justifyItems: 'self-end',
                }}
              >
                Please confirm the contract of sale or agreed ammendments for{' '}
                {
                  getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                    ?.streetName
                }{' '}
                has been reveiwed by your legal representative and is now ready
                for upload.
              </Typography>
            </Grid>
            <Grid sx={{ marginTop: '20px' }}>
              <Typography
                sx={{
                  fontFamily: 'poppins!important',
                  fontSize: matchessm ? '12px' : '16px!important',
                  fontWeight: 400,
                  color: '#666666',
                  justifyContent: 'center',
                  alignItems: 'center',

                  marginTop: '0px',
                  justifyItems: 'self-end',
                }}
              >
                By confirming you will be required to upload the reviewed
                documents.
              </Typography>
            </Grid>
            <Grid sx={{ marginTop: '20px' }}>
              <Typography
                sx={{
                  fontFamily: 'poppins!important',
                  fontSize: matchessm ? '12px' : '16px!important',
                  fontWeight: 400,
                  color: '#666666',
                  justifyContent: 'center',
                  alignItems: 'center',

                  marginTop: '0px',
                  justifyItems: 'self-end',
                }}
              >
                Alternatively you can cancel this request and select{' '}
                <span style={{ fontWeight: 600, color: '#000000' }}>
                  Forward to solicitor
                </span>{' '}
                from the action menu, to connect them directly to retreX.
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            gap={matchessm ? '9px' : 2}
            marginTop={matchessm ? '10px' : '45px'}
            justifyContent={'end'}
          >
            <Grid item>
              <Button
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 20px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
                onClick={() => {
                  setUploadDocuments(false);
                }}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
              <Button
                onClick={() => {
                  setUploadDocumentsone(true);
                  setUploadDocuments(false);
                }}
                disabled={loading}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 18px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
              >
                &nbsp;Confirm&nbsp;
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>

      <Dialog
        PaperProps={{
          sx: {
            borderRadius: '8px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: '25px',
            zIndex: '1000000',
            minWidth: matchessm ? '95%' : '650px',
          },
        }}
        open={uploaddocumentsone}
      >
        <Grid container>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            sx={{ mb: 2 }}
          >
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '12px' : '14px',
                color: '#666666',
              }}
            >
              {getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                ?.streetName || '-'}
            </Typography>
          </Grid>
          <Grid container>
            <Grid
              item
              xs={12}
              display={'flex'}
              alignItems={'center'}
              padding={'10px 0px'}
            >
              <Pendingwarning />
              <Typography
                sx={{
                  ...poppins500,
                  fontSize: matchessm ? '16px' : '24px',
                  color: '#000000',
                  marginLeft: '10px',
                }}
              >
                Please select documents for upload
              </Typography>
            </Grid>
            <Grid item xs={12} sx={{ marginTop: '20px' }}>
              <FormGroup aria-label="position" column>
                <Box>
                  <Box sx={{ width: 'min-content' }}>
                    <FormControlLabel
                      value="Amendments"
                      sx={{ marginLeft: '-25px' }}
                      control={
                        <Checkbox
                          sx={{
                            '& .MuiSvgIcon-root': {
                              fontSize: 28,
                            },
                            '&.Mui-checked': {
                              color: '#965CF0',
                            },
                            '&.Mui-disabled': {
                              color: '#965CF0',
                              pointerEvents: 'none',
                            },
                            '&.MuiCheckbox-colorPrimary': {
                              color: '#965CF0',
                            },
                          }}
                          onChange={(e) => setAmend(e.target.checked)}
                        />
                      }
                      label={
                        <Typography
                          sx={{
                            fontSize: '18px',
                            fontFamily: 'Poppins',
                          }}
                        >
                          Amendments
                        </Typography>
                      }
                      labelPlacement="end"
                    />
                  </Box>
                  {amendMedia.length == 0 && (
                    <Grid item sx={{ display: amend ? 'block' : 'none' }}>
                      <DropZone
                        {...getRootProps()}
                        isDragAccept={isDragAccept}
                        isDragReject={isDragReject}
                        style={{
                          height: '100px',
                          border: amendVal && '1px solid red',
                        }}
                      >
                        <p className={classes.pdfUploadText}>
                          {isDragAccept ? (
                            'All files are accepted'
                          ) : isDragReject ? (
                            'Some files are rejected'
                          ) : (
                            <>
                              <Grid
                                container
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  px: '10px',
                                }}
                              >
                                <Grid item>
                                  <AddCircleOutlineIcon
                                    style={{
                                      color: '#965CF0',
                                      fontSize: matchessm ? '14px' : '25px',
                                    }}
                                  />
                                </Grid>
                                <Grid item>Upload or Drag here</Grid>
                              </Grid>
                            </>
                          )}
                        </p>
                        <input
                          {...getInputProps()}
                          onChange={(event) => handleAmendFileUpload(event)}
                        />
                      </DropZone>
                    </Grid>
                  )}
                  <Grid sx={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                    {amendMedia.map((file) => (
                      <Grid
                        style={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          padding: '0px 0px 20px 0px',
                        }}
                        className={classes.MaxPdfBox}
                        key={file.name}
                      >
                        <Box
                          title={file.name}
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src={PdfIcon}
                            style={{ width: '80px', height: '65px' }}
                            alt="pdficon"
                          />
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              width: '100%',
                              mt: '4px',
                              gap: '8px',
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: '12px',
                                fontFamily: 'Poppins',
                              }}
                            >
                              {file.name.length > 10
                                ? `${file.name.slice(0, 10)}...`
                                : file.name}
                            </Typography>
                            <img
                              onClick={() =>
                                setAmendMedia((prevFiles) =>
                                  prevFiles.filter((f) => f.name !== file.name)
                                )
                              }
                              src={DeleteIcon}
                              style={{
                                width: '20px',
                                height: '20px',
                                cursor: 'pointer',
                              }}
                              alt="delete"
                            />
                          </Box>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                  {amend && (
                    <Grid
                      item
                      className={classes.MaxPdfBox}
                      sx={{ marginBottom: '10px', marginTop: '-10px' }}
                    >
                      <Typography
                        sx={{
                          ...poppins400,
                          fontSize: matchessm ? '10px' : '14px',
                          color: amendVal && 'red',
                        }}
                        className={classes.pdfUploadMaxText}
                      >
                        {amendMedia.length === 0 && (
                          <>{amendVal && 'Please upload Amendments document'}</>
                        )}
                      </Typography>
                    </Grid>
                  )}
                </Box>
                <Box>
                  <Box sx={{ width: 'min-content', whiteSpace: 'nowrap' }}>
                    <FormControlLabel
                      onClick={() => setContractSale(!contractSale)}
                      sx={{ marginLeft: '-25px' }}
                      value="Contract of Sale"
                      control={
                        <Checkbox
                          sx={{
                            '& .MuiSvgIcon-root': {
                              fontSize: 28,
                            },
                            '&.Mui-checked': {
                              color: '#965CF0',
                            },
                            '&.Mui-disabled': {
                              color: '#965CF0',
                              pointerEvents: 'none',
                            },
                          }}
                          checked={contractSale}
                          disabled
                          onChange={(e) => setContractSale(e.target.checked)}
                        />
                      }
                      label={
                        <Typography
                          sx={{
                            fontSize: '18px',
                            fontFamily: 'Poppins',
                          }}
                        >
                          Contract of Sale{' '}
                          <span style={{ color: 'red', fontSize: '20px' }}>
                            *
                          </span>
                        </Typography>
                      }
                      labelPlacement="end"
                    />
                  </Box>
                  {contractMedia.length == 0 && (
                    <Grid item>
                      <DropZone
                        {...getContractRootProps()}
                        isDragAccept={isDragAccept}
                        isDragReject={isDragReject}
                        style={{
                          height: '100px',
                          border: contractVal && '1px solid red',
                        }}
                      >
                        <p className={classes.pdfUploadText}>
                          {isDragAccept ? (
                            'All files are accepted'
                          ) : isDragReject ? (
                            'Some files are rejected'
                          ) : (
                            <>
                              <Grid
                                container
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  px: '10px',
                                }}
                              >
                                <Grid item>
                                  <AddCircleOutlineIcon
                                    style={{
                                      color: '#965CF0',
                                      fontSize: matchessm ? '14px' : '25px',
                                    }}
                                  />
                                </Grid>
                                <Grid item>Upload or Drag here</Grid>
                              </Grid>
                            </>
                          )}
                        </p>
                        <input
                          {...getContractInputProps()}
                          onChange={(e) => handleContractFileUpload(e)}
                        />
                      </DropZone>
                    </Grid>
                  )}
                  <Grid sx={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                    {contractMedia.map((file) => (
                      <Grid
                        style={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          padding: '0px 0px 20px 0px',
                        }}
                        className={classes.MaxPdfBox}
                        key={file.name}
                      >
                        <Box
                          title={file.name}
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src={PdfIcon}
                            style={{ width: '80px', height: '65px' }}
                            alt="pdficon"
                          />
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              width: '100%',
                              mt: '4px',
                              gap: '8px',
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: '12px',
                                fontFamily: 'Poppins',
                              }}
                            >
                              {file.name.length > 10
                                ? `${file.name.slice(0, 10)}...`
                                : file.name}
                            </Typography>
                            <img
                              onClick={() =>
                                setContractMedia((prevFiles) =>
                                  prevFiles.filter((f) => f.name !== file.name)
                                )
                              }
                              src={DeleteIcon}
                              style={{
                                width: '20px',
                                height: '20px',
                                cursor: 'pointer',
                              }}
                              alt="delete"
                            />
                          </Box>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                  {contractSale &&
                    contractMedia.length === 0 &&
                    contractVal && (
                      <Grid
                        item
                        className={classes.MaxPdfBox}
                        sx={{ marginBottom: '10px', marginTop: '-10px' }}
                      >
                        <Typography
                          sx={{
                            ...poppins400,
                            fontSize: matchessm ? '10px' : '14px',
                            color: contractVal && 'red',
                          }}
                          className={classes.pdfUploadMaxText}
                        >
                          {contractMedia.length === 0 && (
                            <>
                              {contractVal &&
                                'Please upload Contract of sale document'}
                            </>
                          )}
                        </Typography>
                      </Grid>
                    )}
                </Box>
              </FormGroup>
            </Grid>
            <Grid item xs={12} sx={{ marginTop: '20px' }}>
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontSize: '20px',
                  fontWeight: 500,
                }}
              >
                Reviewed by :{' '}
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  marginTop: '20px',
                  gap: '10px',
                }}
              >
                <Typography sx={{ fontFamily: 'poppins', fontSize: '18px' }}>
                  Self
                </Typography>
                <IconButton onClick={() => setToggle(!toggle)}>
                  {!toggle ? <ToggleOff /> : <ToggleOn />}
                </IconButton>
                <Typography sx={{ fontFamily: 'poppins', fontSize: '18px' }}>
                  Legal Representative
                </Typography>
              </Box>
            </Grid>
            {toggle && (
              <Grid item xs={12} sx={{ marginTop: '20px' }}>
                <Typography
                  sx={{
                    fontFamily: 'poppins',
                    fontSize: '20px',
                    fontWeight: 500,
                  }}
                >
                  Legal Representative Details
                </Typography>
                <Grid
                  container
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                    marginTop: '20px',
                  }}
                >
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      placeholder="First Name"
                      sx={{
                        height: matches700 && '40px',
                        width: '100%',
                        '& .MuiInputBase-root': {
                          height: '100%',
                          fontSize: matches700 && '14px',
                        },
                        '& .MuiInputBase-input': {
                          padding: '10px 14px',
                        },
                      }}
                      error={firstVal}
                      value={capitalize(firstName)}
                      onChange={(event) => {
                        setFirstName(event.target.value);
                        setFirstVal(false);
                      }}
                      InputProps={{
                        sx: {
                          fontSize: '18px',
                          fontFamily: 'Poppins',
                        },
                      }}
                      inputProps={{
                        maxLength: 30,
                        sx: {
                          '::placeholder': {
                            fontSize: matches700 ? '14px' : '16px',
                            fontFamily: 'Poppins',
                            color: 'gray',
                            opacity: 1,
                          },
                        },
                      }}
                    />
                    <span
                      style={{
                        color: 'red',
                        fontFamily: 'poppins',
                        fontSize: '12px',
                        visibility: firstVal ? 'visible' : 'hidden',
                      }}
                    >
                      Enter legal representative's first name
                    </span>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      placeholder="Last Name"
                      sx={{
                        height: matches700 && '40px',
                        width: '100%',
                        '& .MuiInputBase-root': {
                          height: '100%',
                          fontSize: matches700 && '14px',
                        },
                        '& .MuiInputBase-input': {
                          padding: '10px 14px',
                        },
                      }}
                      value={capitalize(lastName)}
                      error={lastVal}
                      onChange={(event) => {
                        setLastName(event.target.value);
                        setLastVal(false);
                      }}
                      InputProps={{
                        sx: {
                          fontSize: '18px',
                          fontFamily: 'Poppins',
                        },
                      }}
                      inputProps={{
                        maxLength: 30,
                        sx: {
                          '::placeholder': {
                            fontSize: matches700 ? '14px' : '16px',
                            fontFamily: 'Poppins',
                            color: 'gray',
                            opacity: 1,
                          },
                        },
                      }}
                    />
                    <span
                      style={{
                        color: 'red',
                        fontFamily: 'poppins',
                        fontSize: '12px',
                        visibility: lastVal ? 'visible' : 'hidden',
                      }}
                    >
                      Enter legal representative's last name
                    </span>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      placeholder="Email"
                      sx={{
                        height: matches700 && '40px',
                        width: '100%',
                        '& .MuiInputBase-root': {
                          height: '100%',
                          fontSize: matches700 && '14px',
                        },
                        '& .MuiInputBase-input': {
                          padding: '10px 14px',
                        },
                      }}
                      value={email}
                      error={emailVal}
                      onChange={(event) => handleEmail(event)}
                      InputProps={{
                        sx: {
                          fontSize: '18px',
                          fontFamily: 'Poppins',
                        },
                      }}
                      inputProps={{
                        sx: {
                          '::placeholder': {
                            fontSize: matches700 ? '14px' : '16px',
                            fontFamily: 'Poppins',
                            color: 'gray',
                            opacity: 1,
                          },
                        },
                      }}
                    />
                    <span
                      style={{
                        color: 'red',
                        fontFamily: 'poppins',
                        fontSize: '12px',
                        visibility: errorMessage
                          ? 'visible'
                          : emailVal
                          ? 'visible'
                          : 'hidden',
                      }}
                    >
                      {errorMessage
                        ? errorMessage
                        : "Enter legal representative's email"}
                    </span>
                  </Grid>
                </Grid>
              </Grid>
            )}
          </Grid>

          <Grid
            container
            gap={matchessm ? '9px' : 2}
            marginTop={matchessm ? '10px' : '45px'}
            justifyContent={'end'}
            sx={{ marginBottom: matches400 && '40px' }}
          >
            <Grid item>
              <Button
                variant="outlined"
                disabled={loading}
                style={{
                  padding: matchessm ? '6px 20px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
                onClick={cancelFunc}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
              <Button
                onClick={uploadDocumentValidate}
                variant="outlined"
                disabled={loading}
                style={{
                  padding: matchessm ? '6px 18px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
              >
                &nbsp;Upload&nbsp;
              </Button>
              {loading ? (
                <img
                  alt="Logo"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '40px', width: '40px' }}
                />
              ) : null}
            </Grid>
          </Grid>
        </Grid>
      </Dialog>

      <SolicitorPopupHandler
        open={opensolicitorpopup}
        onClose={() => setOpensolicitorpopup(false)}
        actionType={typeofsolicitorpopup}
        propertyId={propertyId}
        checkListArray={checkListArray}
        propertyAddress={
          getBuyerIndividualValue?.PropertyDetails?.propertyAddress?.streetName
        }
        groupCall={groupCall}
      />
      {dontallowtooffer && (
        <MarketInvitePopup
          open={dontallowtooffer}
          address={
            getBuyerIndividualValue?.PropertyDetails?.propertyAddress
              ?.streetName
          }
          onClose={setDontallowtooffer}
          dontallowtooffer={true}
          showActivateTradeForSharePage={showActivateTradeForSharePage}
          tabData={tabData}
          setTabDAta={setTabDAta}
        />
      )}

      {paymentPop && (
        <DepositPaymentRemittancePopup
          open={paymentPop}
          getBuyerIndividualValue={getBuyerIndividualValue}
          groupCall={groupCall}
          groupIt={groupIt}
          setPaymentPop={setPaymentPop}
        />
      )}
    </>
  );
};

export function HighestOffer1({
  getBuyerIndividualValue,
  dateupdated,
  userDetail,
  setShowActivateTrade,
  setHideActivateTrade,
  setTabDAta,
  onShowChat,
  sharedpage,
  activityupdate,
}) {
  return (
    <Grid
      item
      xs={4}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        scrollBehavior: 'smooth',
        background: 'white',
        color: '#fff',
        fontSize: '2em',
        height: '100%',
        minWidth: '100%',
        scrollbarWidth: 'none',
      }}
    >
      <MediaQuery minWidth={0}>
        <Paper
          className="rightConetnt"
          style={{
            maxHeight: '95%',
            overflow: 'auto',
            height: 'auto',
          }}
          sx={{
            '&::-webkit-scrollbar': { display: 'none' },
            scrollbarWidth: 'none',
          }}
        >
          <List sx={{ paddingTop: '0px' }}>
            <Stack
              sx={{
                width: '333px',
                height: '507px',
                backgroundColor: 'rgba(255, 255, 255, 0.77)',
                borderRadius: '5px',
                border: '0.5px solid #F0F0F0',
              }}
            >
              <Stack
                sx={{
                  marginLeft: '8px',
                  marginTop: '12px',
                  marginRight: '8px',
                  height: '59px',
                  background: '#F7F8F7',
                  borderRadius: '6px',
                  padding: '10px',
                }}
              >
                <Typography
                  sx={{
                    textAlign: 'center',
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '500 !important',
                    fontSize: '20px',
                    color: '#6C2AD2',
                  }}
                >
                  Highest Offer
                </Typography>
              </Stack>

              {getBuyerIndividualValue?.PropertyDetails?.highestOffer ? (
                <Stack sx={{ paddingTop: '20px', paddingLeft: '30px' }} gap={1}>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontStyle: 'normal !important',
                      fontWeight: '500 !important',
                      fontSize: '30px',
                      color: '#112347',
                      textAlign: 'center',
                    }}
                  >
                    {`${
                      getBuyerIndividualValue?.PropertyDetails?.highestOffer ||
                      '-'
                    }`}
                    <sup>
                      {getBuyerIndividualValue?.PropertyDetails
                        ?.highestOfferIsConditional == 1 ? (
                        <Dot />
                      ) : (
                        <GreenDot />
                      )}
                    </sup>
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontStyle: 'normal !important',
                      fontWeight: '400 !important',
                      fontSize: '12px',
                      color: 'rgba(17, 35, 71, 0.5)',

                      textAlign: 'center',
                    }}
                  >
                    Last Updated : &nbsp;
                    {dateupdated}
                  </Typography>

                  <Box
                    sx={{
                      fontFamily: 'Poppins',
                      fontStyle: 'normal',
                      fontWeight: 300,
                      fontSize: '16px',
                      color: '#112347',
                      marginTop: '3.33px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '7px',
                      width: '100%',
                      minWidth: 0,
                    }}
                  >
                    {USER_TYPE === 'Buyer' &&
                    getBuyerIndividualValue?.PropertyDetails
                      ?.highestOfferBuyerCodeId != userDetail?.userAppId ? (
                      <Avatar
                        src={userIcon}
                        alt={
                          getBuyerIndividualValue?.PropertyDetails
                            ?.highestOfferBuyerName
                        }
                        sx={{
                          height: '36.5px',
                          width: '36.5px',
                          flexShrink: 0,
                        }}
                      />
                    ) : getBuyerIndividualValue?.PropertyDetails
                        ?.highestOfferBuyerProfile == '' ||
                      getBuyerIndividualValue?.PropertyDetails
                        ?.highestOfferBuyerProfile == null ? (
                      <Avatar
                        sx={{
                          width: '36px',
                          height: '36px',
                          backgroundColor: '#666666',
                          fontFamily: 'Poppins',
                          fontSize: '18px',
                          flexShrink: 0,
                        }}
                      >
                        {getBuyerIndividualValue?.PropertyDetails
                          ?.highestOfferBuyerNameInitial || ''}
                      </Avatar>
                    ) : (
                      <Avatar
                        src={
                          getBuyerIndividualValue?.PropertyDetails
                            ?.highestOfferBuyerProfile
                        }
                        alt={
                          getBuyerIndividualValue?.PropertyDetails
                            ?.highestOfferBuyerName
                        }
                        sx={{
                          height: '36.5px',
                          width: '36.5px',
                          flexShrink: 0,
                        }}
                      />
                    )}

                    {/* Name / Buyer ID */}
                    <Box
                      sx={{
                        minWidth: 0,
                        maxWidth: 'calc(100% - 43px)',
                        overflow: 'hidden',
                      }}
                    >
                      {getBuyerIndividualValue?.PropertyDetails
                        ?.highestOfferBuyerCodeId === userDetail?.userAppId ? (
                        <NameTooltip
                          name={
                            getBuyerIndividualValue?.PropertyDetails
                              ?.highestOfferBuyerName || ''
                          }
                        >
                          <Typography
                            component="span"
                            sx={{
                              display: 'block',
                              width: '100%',
                              minWidth: 0,
                              fontFamily: 'Poppins',
                              fontWeight: 300,
                              fontSize: '16px',
                              color: '#112347',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              cursor: 'pointer',
                            }}
                          >
                            {getBuyerIndividualValue?.PropertyDetails
                              ?.highestOfferBuyerName || ''}
                          </Typography>
                        </NameTooltip>
                      ) : getBuyerIndividualValue?.PropertyDetails?.stage ===
                        'ST2' ? (
                        <Typography
                          component="span"
                          sx={{
                            display: 'block',
                            width: '100%',
                            minWidth: 0,
                            fontFamily: 'Poppins',
                            fontWeight: 300,
                            fontSize: '16px',
                            color: '#112347',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          {
                            getBuyerIndividualValue?.PropertyDetails
                              ?.highestOfferBuyerCodeId
                          }
                        </Typography>
                      ) : (
                        <Typography
                          component="span"
                          sx={{
                            display: 'block',
                            width: '100%',
                            minWidth: 0,
                            fontFamily: 'Poppins',
                            fontWeight: 300,
                            fontSize: '16px',
                            color: '#112347',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          {
                            getBuyerIndividualValue?.PropertyDetails
                              ?.highestOfferUniqueId
                          }
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Stack>
              ) : (
                <Typography
                  sx={{
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '300 !important',
                    fontSize: '16px',
                    color: '#112347',
                    padding: '20px',
                    textAlign: 'center',
                  }}
                >
                  Not available
                </Typography>
              )}

              <Grid
                container
                direction={'row'}
                spacing={'2'}
                marginTop={'5%'}
                justifyContent={'center'}
              >
                <Grid item marginTop={'5px'}>
                  <Clock />
                </Grid>
                <Grid item>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontStyle: 'normal !important',
                      fontWeight: '500 !important',
                      fontSize: '16px',
                      color: '#212529',
                      marginLeft: '11px',
                    }}
                  >
                    Offers close in:
                  </Typography>
                </Grid>
              </Grid>
              <Card
                sx={{
                  marginLeft: '15px',
                  marginTop: '15px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  height: '151px',
                  width: '300px',
                  background: '#FFFFFF',
                  boxShadow: 'none',
                  letterSpacing: '1%',
                }}
              >
                <PropertyTimer
                  propertyData={getBuyerIndividualValue?.PropertyDetails}
                  timerStatus={
                    getBuyerIndividualValue?.PropertyDetails?.timerStatus
                  }
                  stage={getBuyerIndividualValue?.PropertyDetails?.stage}
                />
              </Card>
              {(USER_TYPE === 'Buyer' || !USER_TYPE) && (
                <Button
                  sx={{
                    textTransform: 'none',
                    width: '162px',
                    height: '43px',
                    borderRadius: '5px',
                    bgcolor: '#33A745',
                    alignSelf: 'center',
                    color: '#FFFFFF',
                    ...poppins500,
                    fontSize: '16px',
                    '&:hover': {
                      bgcolor: '#33A745',
                      color: '#FFFFFF',
                      boxShadow: 'none',
                    },
                  }}
                  onClick={async () => {
                    await setShowActivateTrade(true);
                    await setHideActivateTrade(false);
                    await setTabDAta('4');
                    window.scroll({
                      top: 1900,
                      behavior: 'smooth',
                    });
                  }}
                >
                  Make an Offer
                </Button>
              )}
            </Stack>
            <Grid
              container
              sx={{
                marginTop: '20px',
                width: '326px',
                height: '224px',
                background: '#FFFFFF',
                borderRadius: '5px',
                border: '1px solid #E4E4E4',
              }}
            >
              <Grid container spacing={'1'}>
                <Grid item xs={8} sx={{ marginTop: '5px' }}>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontStyle: 'normal !important',
                      fontWeight: '500 !important',
                      fontSize: '16px',
                      color: '#000000',

                      marginLeft: '15px',
                    }}
                  >
                    retreX Buyer Protection
                  </Typography>
                  <Stack direction={'column'} spacing={'1'}>
                    <Stack
                      direction={'row'}
                      spacing={1}
                      alignItems={'center'}
                      paddingTop={'8px'}
                      paddingLeft={'15px'}
                    >
                      <img
                        src={Offer1}
                        alt="Exchange"
                        style={{
                          width: '30px',
                          height: '30px',
                          marginTop: '5px',
                          marginLeft: '5px',
                        }}
                      />
                      <Typography
                        sx={{
                          fontFamily: 'Poppins !important',
                          fontStyle: 'normal !important',
                          fontWeight: '400 !important',
                          fontSize: '12px',
                          color: '#112347',
                        }}
                      >
                        Transparent Offering
                      </Typography>
                    </Stack>
                    <Stack
                      direction={'row'}
                      spacing={1}
                      alignItems={'center'}
                      paddingTop={'8px'}
                      paddingLeft={'15px'}
                    >
                      <img
                        src={Exchange}
                        alt="Exchange"
                        style={{
                          width: '30px',
                          height: '30px',
                          marginTop: '5px',
                          marginLeft: '5px',
                        }}
                      />
                      <Typography
                        sx={{
                          fontFamily: 'Poppins !important',
                          fontStyle: 'normal !important',
                          fontWeight: '400 !important',
                          fontSize: '12px',
                          color: '#112347',
                        }}
                      >
                        Instant Exchange<sup>*</sup>
                      </Typography>
                    </Stack>
                    <Stack
                      direction={'row'}
                      spacing={1}
                      alignItems={'center'}
                      paddingTop={'8px'}
                      paddingLeft={'15px'}
                    >
                      <img
                        src={Man}
                        alt="Man"
                        style={{
                          width: '30px',
                          height: '30px',
                          marginTop: '5px',
                          marginLeft: '5px',
                        }}
                      />
                      <Typography
                        sx={{
                          fontFamily: 'Poppins !important',
                          fontStyle: 'normal !important',
                          fontWeight: '400 !important',
                          fontSize: '12px',
                          color: '#112347',
                        }}
                      >
                        Anonymous & Secure
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid>
                <Grid item xs={4}>
                  <Stack direction={'column'} marginLeft={'20px'}>
                    <Shield1 />
                  </Stack>
                </Grid>
              </Grid>
              <Stack sx={{ paddingLeft: '20px' }}>
                <Typography
                  sx={{
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '300 !important',
                    fontSize: '12px',
                    color: '#6C2AD2',
                    lineHeight: '18px',
                  }}
                >
                  Learn more about retreX Buyer Protection
                </Typography>
              </Stack>
            </Grid>
            {!sharedpage && (
              <Stack
                sx={{
                  width: '326px',
                  height: '500px',
                  maxHeight: 'auto',
                  overflow: 'scroll',
                  background: '#FFFFFF',
                  borderRadius: '5px',

                  alignContent: 'center',

                  paddingBottom: '20px',
                  marginBottom: '10px',
                  marginY: '20px',
                }}
              >
                <MessagingContainer
                  onShowChat={onShowChat}
                  binders={true}
                  market={true}
                  activityupdate={activityupdate}
                />
              </Stack>
            )}
          </List>
        </Paper>
      </MediaQuery>
    </Grid>
  );
}

function BuyingActions({
  tabData,
  setTabData,
  setNewTabData,
  cancelButton,
  buttonStyles,
  typographyStyles,
  newTabData,
  SetHideOthers,
  cancelButtonStyles,
  setShowPropertyTimer,
  cancelTextStyles,
  handleScrollToTop,
  matchessm,
}) {
  const actions = [
    { id: '1', label: 'Organise Inspection', Icon: SearchIconNew },
    { id: '2', label: 'View Contract', Icon: ContractIconNew },
    { id: '3', label: 'Due Diligence', Icon: DiligenceIconNew },
    { id: '4', label: 'Make Offer', Icon: MakeOfferIconNew },
  ];
  const scrollContainerRef = useRef(null);
  return (
    <Grid sx={{ width: '100%', marginTop: tabData == '2' && '130px' }}>
      <Typography
        sx={{
          fontFamily: 'Poppins',
          fontWeight: 500,
          fontSize: '20px',
          color: '#112347',
        }}
      >
        Buying Actions
      </Typography>

      <Grid
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          margin: '25px 0',
          zIndex: -1,
        }}
      >
        {actions.map(({ id, label, Icon }) => (
          <Button
            key={id}
            onClick={() => {
              handleScrollToTop();
              setTabData(id);
              setNewTabData(true);
              if (matchessm) {
                if (scrollContainerRef.current) {
                  scrollContainerRef.current.scrollTo(0, 0);
                } else {
                  window.scrollTo(0, 0);
                }
              }
            }}
            style={{
              ...buttonStyles.base,
              ...(tabData === id && newTabData
                ? !(label == 'Make Offer') && buttonStyles.selected
                : {}),
              backgroundColor:
                label == 'Make Offer'
                  ? '#6C2AD2'
                  : tabData === id && newTabData
                  ? '#F0F0F0'
                  : 'white',
            }}
            variant="contained"
          >
            <Box sx={{ display: 'flex', alignItems: 'center', width: '240px' }}>
              <Icon
                color={
                  label == 'Make Offer'
                    ? 'white'
                    : tabData === id && newTabData
                    ? '#C4C4C4'
                    : '#6C2AD2'
                }
              />
              <Typography
                sx={{
                  ...typographyStyles.base,
                  ...(tabData === id && newTabData
                    ? !(label == 'Make Offer') && typographyStyles.selected
                    : {}),
                  color:
                    label == 'Make Offer'
                      ? 'white'
                      : !(tabData === id && newTabData) && '#6C2AD2',
                }}
              >
                {label}
              </Typography>
            </Box>
          </Button>
        ))}

        {cancelButton && (
          <Button
            onClick={() => {
              setTabData('0');
              setNewTabData(false);
              SetHideOthers(false);
              setShowPropertyTimer(false);
            }}
            style={cancelButtonStyles}
            variant="contained"
          >
            <Box sx={{ display: 'flex', alignItems: 'center', width: '260px' }}>
              <Typography sx={cancelTextStyles}>Cancel</Typography>
            </Box>
          </Button>
        )}
      </Grid>
    </Grid>
  );
}
